webpackJsonp([1],{

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(754),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c650d308",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports) {

exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-402.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-402.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(504);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1cc57730", content, true);

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".title{margin:0;padding:0;height:5rem;background:#fff}.title img,.title p{display:block;height:5rem}.title img{width:100%}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/downloadHeader.vue"],"names":[],"mappings":"AACA,OACE,SAAU,AACV,UAAW,AACX,YAAa,AACb,eAAiB,CAClB,AAKD,oBAHE,cAAe,AACf,WAAa,CAMd,AAJD,WACE,UAAY,CAGb","file":"downloadHeader.vue","sourcesContent":["\n.title {\n  margin: 0;\n  padding: 0;\n  height: 5rem;\n  background: #fff;\n}\n.title p {\n  display: block;\n  height: 5rem;\n}\n.title img {\n  width: 100%;\n  height: 5rem;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headerTitle',
    data: function data() {
        var query = this.$route.query || {};
        return {
            imageSrc: query && (query.language === 'en' || query.language === 'es') ? __webpack_require__(506)("./header-" + query.language + '.jpg') : __webpack_require__(509),
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
        };
    },
    mounted: function mounted() {
        var utilObj = __webpack_require__(500);
        utilObj.checkOperamini();
        if (utilObj.checkOperamini()) {
            ga('send', 'event', 'm', 'browers', 'opreamini');
        }
    },

    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(500);
            utilObj.checkOperamini();
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'download', 'opreamini');
            }
            fbq('track', 'Lead');
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.iPad = ua.match(/ipad/);
            browers.iPhone = ua.match(/iphone/);
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            browers.ie = ua.match(/iemobile/);
            browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
            browers.force_ssl = ua.match(/Android (5|6)/i);
            browers.is_ios_6 = ua.match(/iOS 6/i);
            browers.is_liveapp = ua.match(/LiveApp/i);
            if (browers.iOS) {
                utilObj.jumpUrl();
            } else if (browers.Android) {
                location.href = '/download';
            }
        }
    }
});

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./header-en.jpg": 507,
	"./header-es.jpg": 508
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-en.3375c0e.jpg";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-es.fac9b76.jpg";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header.93b20d6.png";

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isInApp) ? _vm._m(0) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', {
    on: {
      "click": _vm.jumpUrl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.imageSrc),
      "alt": "download All Football App",
      "width": "100%"
    }
  })])])
}]}

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ff868c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1eb036a8", content, true);

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#download-popup[data-v-5ff868c8]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;background-color:rgba(0,0,0,.6)}#download-popup .popup-body[data-v-5ff868c8]{position:relative;width:75%;height:200px;margin:0 auto;margin-top:10rem;background-size:100%}#download-popup .popup-body-head[data-v-5ff868c8]{display:block;width:140px;margin:0 auto}#download-popup .popup-body-content[data-v-5ff868c8]{margin-top:-45px;padding-bottom:10px;border-radius:5px;background:#fff}#download-popup .popup-body-clsoe[data-v-5ff868c8]{position:absolute;top:-.5rem;right:-.5rem;width:2.6rem;height:2.6rem;line-height:1.6rem}#download-popup .popup-body-go[data-v-5ff868c8]{display:block;width:90%;height:2.6rem;margin:0 auto;margin-top:5px;color:#fff;text-align:center;line-height:2.6rem;border-radius:5px;font-weight:800;background-color:#25c023}#download-popup .popup-body-text[data-v-5ff868c8]{padding:0 10px;padding-top:50px;margin-bottom:15px;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/downloadPopup.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,+BAAqC,CACtC,AACD,6CACE,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,cAAe,AACf,iBAAkB,AAClB,oBAAsB,CACvB,AACD,kDACE,cAAe,AACf,YAAa,AACb,aAAe,CAChB,AACD,qDACE,iBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,kBAAmB,AACnB,WAAa,AACb,aAAe,AACf,aAAc,AACd,cAAe,AACf,kBAAoB,CACrB,AACD,gDACE,cAAe,AACf,UAAW,AACX,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,kDACE,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadPopup.vue","sourcesContent":["\n#download-popup[data-v-5ff868c8] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n#download-popup .popup-body[data-v-5ff868c8] {\n  position: relative;\n  width: 75%;\n  height: 200px;\n  margin: 0 auto;\n  margin-top: 10rem;\n  background-size: 100%;\n}\n#download-popup .popup-body-head[data-v-5ff868c8] {\n  display: block;\n  width: 140px;\n  margin: 0 auto;\n}\n#download-popup .popup-body-content[data-v-5ff868c8] {\n  margin-top: -45px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  background: #fff;\n}\n#download-popup .popup-body-clsoe[data-v-5ff868c8] {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.5rem;\n  width: 2.6rem;\n  height: 2.6rem;\n  line-height: 1.6rem;\n}\n#download-popup .popup-body-go[data-v-5ff868c8] {\n  display: block;\n  width: 90%;\n  height: 2.6rem;\n  margin: 0 auto;\n  margin-top: 5px;\n  color: #fff;\n  text-align: center;\n  line-height: 2.6rem;\n  border-radius: 5px;\n  font-weight: 800;\n  background-color: #25c023;\n}\n#download-popup .popup-body-text[data-v-5ff868c8] {\n  padding: 0 10px;\n  padding-top: 50px;\n  margin-bottom: 15px;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            popup_show: false,
            popup_text: 'Download All Football App to enjoy the best football experience',
            popp_btn: true,
            now_local_date: new Date().toLocaleDateString()
        };
    },
    mounted: function mounted() {
        if (!window.sessionStorage) {
            window.sessionStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        if (!window.localStorage) {
            window.localStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        this.recodePopupState();
    },

    methods: {
        closePopop: function closePopop() {
            this.popup_show = false;
            var start_date = sessionStorage.getItem('start_date');
            var end_time = new Date().valueOf();
        },
        goDownload: function goDownload() {
            sessionStorage.setItem('loop_run', 'true');
            this.popup_show = false;
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                location.href = '/download';
            } else if (browers.iOS) {
                var utilObj = __webpack_require__(500);
                utilObj.jumpUrl();
            }
        },
        recodePopupState: function recodePopupState() {
            if (!localStorage.getItem('local_date')) {
                this.showPopup();
            } else {
                var local_date = localStorage.getItem('local_date');
                if (local_date != this.now_local_date) {
                    this.showPopup();
                } else {
                    return;
                }
            }
            if (!sessionStorage.getItem('start_date')) {
                var start_date = new Date().valueOf();
                sessionStorage.setItem('start_date', start_date);
            }
        },
        showPopup: function showPopup(is_stop) {
            var that = this;
            var type = this.$route.query && this.$route.query.type;
            var isInApp =  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL;
            var loopFn = function loopFn() {
                if (isInApp) {
                    return;
                }

                var start_date = sessionStorage.getItem('start_date');
                var end_time = new Date().valueOf();
                if (sessionStorage.getItem('loop_run') == 'true') {
                    clearInterval(loopFnTimer);
                }
                if ((end_time - start_date) / 1000 >= 30 && (end_time - start_date) / 1000 < 32) {
                    that.popup_show = true;
                } else if ((end_time - start_date) / 1000 >= 60 && (end_time - start_date) / 1000 < 62) {
                    clearInterval(loopFnTimer);

                    if (type === 'share') {
                        return;
                    }
                    if (document.cookie.indexOf('utm_source=ALL_FOOTBALL_PWA')) {
                        return;
                    }
                    var browers = {};
                    var ua = navigator.userAgent.toLowerCase();
                    browers.Android = ua.match(/android/);
                    browers.iOS = ua.match(/ipad|iphone|ios/);
                    if (browers.Android) {
                        that.popup_text = 'Add our website to Home screen or Bookmarks to follow the latest football news.';
                    } else if (browers.iOS) {
                        that.popup_text = 'Add our website to Home screen or Favorites to follow the latest football news.';
                    }
                    that.popp_btn = false;
                    that.popup_show = true;
                    localStorage.setItem('local_date', that.now_local_date);
                } else if ((end_time - start_date) / 1000 > 62) {
                    clearInterval(loopFnTimer);
                }
            };
            var loopFnTimer = setInterval(loopFn, 1000);
        }
    }
});

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_show),
      expression: "popup_show"
    }],
    attrs: {
      "id": "download-popup"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticClass: "popup-body-head",
    attrs: {
      "src": __webpack_require__(516),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body-content"
  }, [_c('p', {
    staticClass: "popup-body-text"
  }, [_vm._v(_vm._s(_vm.popup_text))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popp_btn),
      expression: "popp_btn"
    }],
    staticClass: "popup-body-go",
    on: {
      "click": function($event) {
        _vm.goDownload()
      }
    }
  }, [_vm._v("GO NOW")])]), _vm._v(" "), _c('img', {
    staticClass: "popup-body-clsoe",
    attrs: {
      "src": __webpack_require__(517)
    },
    on: {
      "click": function($event) {
        _vm.closePopop()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_icon.c1b2864.png";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/close_icon.9c943d6.png";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/play@80x80.591d439.png";

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("541f91cc", content, true);

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".btn-download,a.btn-download{text-decoration:none!important;display:block;padding:.4rem;margin:1.4rem .7rem 2.5rem;height:1.8rem;line-height:1.8rem;color:#fff;background:#16ac3a;border-radius:.2rem;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/downloadFooter.vue"],"names":[],"mappings":"AACA,6BAEE,+BAAiC,AACjC,cAAe,AACf,cAAe,AACf,2BAAkC,AAClC,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadFooter.vue","sourcesContent":["\n.btn-download,\na.btn-download {\n  text-decoration: none !important;\n  display: block;\n  padding: .4rem;\n  margin: 1.4rem .7rem 2.5rem .7rem;\n  height: 1.8rem;\n  line-height: 1.8rem;\n  color: #fff;\n  background: #16ac3a;\n  border-radius: .2rem;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'downloadFooter',
    data: function data() {
        return {
            isMatch: false,
            isArticle: false
        };
    },
    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(500);
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'downloadFoot', 'opreamini');
            }
            utilObj.jumpUrl();
        }
    },
    mounted: function mounted() {
        if (window.location.href.indexOf('match') > -1) {
            this.isMatch = true;
        } else {
            this.isArticle = true;
        }
    }
});

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMatch) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v("Download All Football for more matches")]) : _vm._e(), _vm._v(" "), (_vm.isArticle) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadForComments')))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading_circle.eeb3dd9.gif";

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAWlBMVEUAAAC1vMS2vMS2vcS2vMS1vMS2vMS2vcS1vMS2vcS1vMS2vMS2vcS1vMS1vMS1vMS2vMS2vcS2vMS1vMS1vMS2vcS2vcS2vcS2vcS2vcS2vcS1vMS1vMO1vMT8uFU+AAAAHXRSTlMAiO/jM/O9mmIt+thEGAm1cFNMPiDKrKOReBEPgCLrUWEAAADcSURBVEjH7dLJkoMgAEVRhBYZgvPUmvv/v9mmExephCpYJ3fh6p0qVMS3zy7MslzqDDAB6PS9hUbDkAw6sLvjmgxaCEJRJYOKUgjPkgwUze2xpu4NdCLAb+J+lKha9NCn7Qf1P13B9JejIcSW+7ZtY9dwP4viLPa1NI9Kc/93Z7GXOefVKI5q+/Po4vERoFsDr1duxUVAcXu8O6vPA5IqC1gwWcCATQbnTcwCEzoL1I4iCwzQZYEWQhaYUSILKOYomIriUE9dF2gjwPE+v0dAIY9Alk9z14zi2yf2B8c9GmLvZWM/AAAAAElFTkSuQmCC"

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAArlBMVEUAAAD/iwP/iwP/iwP/iwP/iwL/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/iwP/7tr/hgD/q0j//Pf/fQD/ggD/jAL/iQD/kA7/8+T/9+7/eQD/6c3///7/79z/x4X/+fH/p0D/8eD/w33/r1H/nir/lBb/9ej/4b7/1aL/vG3/t2H/3LL/mSH/2Kv/zpSgIcxxAAAAGnRSTlMA8Ob0Kfvsp5veThGPajkhA8e8gnFhWFNHrRtt3BkAAAFOSURBVEjH7dPZboJQFIVhEVAE57lsYO8DCMg8avv+L1ZtiWkipHCt/8XhZn0kJJzBu9dOkUacpHTfL1eESOvuYE6QJEDHzmDHoMgZTDuDLbBCNWHcGUhAeS8wwWvomCB13c/IqNyCwabjXhgh5G6JbN5tfxwxo9TtAMXZYS/L8kFofbOwWAjyB4GhWXpuIqsTpWXjfszzPCcSAVZW5p9PUIdA20ZwnyIySAs7U8NLdL4XRecohUkj4OFaVpV5il1PVVXLrvNdzeAbAWdoru+ZJ01X/2apCa5aQeY8AftCMG0DuvUM9C+kXQ/g2SXSvAcIvQCHSg9gOSmsBz1A9slg2gf4EbJ9H6DHKAr/Ac/zHt9sJThZtoHYdcP7r+Hbvl7nOu03lYdU0wK6nUEQaHVxAjRrASKBYSD7OY1HSBOlBWxGw1sc9/t4NF4M3r1i36NFPw3ZWKZpAAAAAElFTkSuQmCC"

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAOVBMVEUAAAAWsToWsTr///9dwW/1+/aM0Jcztk7g8uO/5MTr9uym2q5uxn3W7dl+y4tKvF/K6M+z37qa1aPYmHFUAAAAAnRSTlMAgJsrThgAAAD3SURBVEjHldPdrgIhDATgObYsC+yPnvd/WLUb0xiwZOaCq35kIIAbmz/wArwAK8ZEH6HAQKQ1RwK8wA+RfwuMxZK0F2OSk2xvIQY70RMbThqIjqiaabHAV6tkZiLQtbI1EEZC46In25Z746InRxVJi5s6FE5sprU9ezd1MSabFLukUiatnNzTJURK3MqJlEuU1Yy6iImmcsurLFErJ9WqvDd/iEbCSZP2eTN7KJzkevXJazqnAp+fJfftXKocLgJiOXd5paqLmFj0vx3zczjxzAV4AV6AF+AFeAFegBfgBXgBXoAX4AV4AV6AF+AFeAFegBfgBXjxBN/6DSG9vEEQAAAAAElFTkSuQmCC"

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_message.26ff204.jpg";

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAANlBMVEUAAAAWrDoWrDr///+S0Jw1sk/e8OH0+vVgvnG64MCg1anT69eCyo9MuGGt27VyxIHH5czq9ev1UaDxAAAAAnRSTlMAgJsrThgAAAG6SURBVGjetdbbboQwDATQKUNICLft//9sW7QKS63W4NX4KU9HVkaWjU5XHwcusBsusBsusBsusBsusBsusBsusG/g/RizccUm15CNS3YuIRtKG0obShvX7Zru2rhsjxzSTRvX7ePt2z6+kBxS0PY7b3rMRufrAdvB53ToURt/9jw0PUdteFl+62EbXpbHy7ctHtatbfGwbm2Lh3VrWzyqW9vHlzoxT72rW9vHa+Zen8Xqo2N7+LjLjTzpQ7prw9hr+fmaZP59dmwPX19nMQ19PEuLl7NN9uEsLT7u3GE33c/SxzPzyW66m6WPF3J6sYdl2PVIlhbfdrzZqUtND9q28+OM2PUasu2fk0znA+hBziHb4o/ffSYyv2Pjv7twJWvQthM6nMdlJnMK2hYvfNVLJue3bJj1kLdnpiSrY7u40Tn129ZPZug9218Wc2arQN/Omkvjk56Kb/u44fv6qHXpfNvH3YrbUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaUNpQ2lDaX6KvJvp9r+CFAAAAAElFTkSuQmCC"

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_playing.6bf00be.png";

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAbBAMAAABlxgnoAAAAHlBMVEUAAAAWsToWsToWsToWsToWsToWsToWsToWsToWsTo67toGAAAACXRSTlMA89WldEAZjMranF6TAAAAdElEQVQY02MoNGNAgJkTHZA4MycFIHFmTk6Ac6ZIzhSBcyYkz5ypCucwBM2caQbnMDgCjYRz2CyBRsI4DKyaQCNhHAYWoJFwDgPISDgHZGQBnMPQCWRhyCD0IEzDtAfhAoTbMF0NMQjhU+xhADEIM9xQQhQAOhxBLkzIy8kAAAAASUVORK5CYII="

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYAgMAAABl+S6cAAAACVBMVEUAAAAWsToWsTrHpKiuAAAAAnRSTlMAxOqay5EAAAAWSURBVAjXY0hhYADiFUByxcCSEJcAAJCIHnFQ5LU1AAAAAElFTkSuQmCC"

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAclBMVEUYrjdPxxpUyRgfsTQyuilFwx8otS8jszJKxB08viU4vCctty1AwCL////d9dj2/PTH7b1z0Vqi4JWf346D1mhWyDJJwi5OxSun4pR81GxMwzbq+OvG68k2uj+557yd3aKB1Idzz3leyGZQwlio4ayS2Zc2JKO0AAAC4klEQVRYw+1S6XriMAx0W9oEisJVjlJu2vd/xdW5wp/AhW/zY3fLOJZGY3niGNIdd/yXeMKnNSfPTzwsx+EEZ2G4m+fy24mVkZmVjxhbUIiNfkhhBK41SCRohdAu4ZgEatUyfqRhhRGDoaLnalSW3bCqsCIXIgimxpkRuEtr7bEm26nOqWoXf4Xhy3H/tWlWlw1fGFUgymRWFNbH/XbTgABrh7cnYjwiOcH6sNuuPoDxsfrcHQCszwcjGakCIcZWn2613R3WvIaG+SvNPTE1ybj3qlWz2e6Pa5HM0Bpz38Tx1SfDKcDma3902Q2lI2xISIj6tCEBwLf4muqv2ZD0/Qnd6roTcrcU8halWgCQYodX7i86OZvG9FoGQFGPaN+wQ5GDk45XAJQ6opgset6qO8WwQ8BoYAfJACrkYN1byUnr1CkD4Fr9btieYY9Tj2aPZo+TaEgBKLOui9JAurdp6LFhGQBFPeJfMOziQHQpG8WkOgBFQ3c5bgCa8ZJ17ZIGs0jdMgBOq/cBMAbvqkfcZIg2w9FsNhoCtGK4HMBE2ORmQ7urzHAMQ6PD3LCfGfYRFvXJ7ooW+rSrgRFmLkekd0U2TRwSxoDsrlwGmBmdqR5xzpDuStikHUO8K6PDk438yYoRNJcMnyNwI6U+zhGA6/gio0NYKOtb1njOEGBudH5qOMWrEDaBwZRyxDWGjjf6seZz+rHeRIkofDIB7wqjO9rfKfpFw8JdOaaLBgbNYvpcMKwx1lbW8a5EjKhtWlRDc6ldi3dV24h2VllbYq41cnrCXdW+Hk5YuzWnVJ+F3VV9M1J5uXXDh2+laPjwG9ou3FWnxrywZk+JiUkOk22b97CqhKdHMbRFHpay7YbcNUYaaNguxDB+cbhILZy74q1+h+0hfPKjx7gQi9ibHkny8aAxSFkXwhfyxeRv0BVzU2KSZze6cMJHgy4hyY6piWVfI0JwSWgy6RqUe82wZdwN/xy/AJgOhPtV4FANAAAAAElFTkSuQmCC"

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(32);
var LIBRARY = __webpack_require__(127);
var wksExt = __webpack_require__(596);
var defineProperty = __webpack_require__(56).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(602),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(600);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1dc664d2", content, true);

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".comments{margin:0;padding:0;width:100%}.comments .sub_line span{display:inline-block;height:20px;font-size:15px;font-weight:600;color:#2d2f32;line-height:20px}.comments .sub_line span:before{display:inline-block;height:24px;width:3px;margin-right:12px;vertical-align:middle;content:\"\";background-color:#16b13a}#comment_list{margin:18px 0;padding:0}#comment_list li{list-style:none;position:relative;padding:0 15px;margin-bottom:12px;overflow:hidden;border-bottom:1px solid #eff1f4}#comment_list .quote{margin:14px 0 6px;padding:10px 12px 8px;background:#eff1f4;color:#999;border-radius:3px}#comment_list .quote .icon_author{position:relative;bottom:1px}#comment_list .quote p{margin:0;font-size:14px;word-break:break-word}#comment_list .quote_author{color:#2d2f32;font-size:14px;height:16px;line-height:16px;margin-bottom:4px}#comment_list .quote_author span{display:inline-block;vertical-align:middle}#comment_list .avatar{position:absolute;top:4px;left:15px;height:30px;width:30px;border-radius:50%}#comment_list .user_info{margin-bottom:0;font-size:14px;width:100%;padding:0}#comment_list .user_info .name{margin:0 0 0 38px;color:#16b13a;float:left}#comment_list .user_info p span{height:20px;line-height:20px;font-size:12px;display:inline-block;vertical-align:middle}#comment_list .icon_v{background-image:url(https://static1.dongqiudi.com/web-new/static/img/V_con_v2.png);background-position:50%;background-size:100% auto;background-repeat:no-repeat;display:inline-block;height:13px;width:13px}#comment_list .icon_author{height:16px;line-height:16px;margin-left:4px;font-size:12px;padding:0 4px;background:#16ac3a;color:#fff;border-radius:4px}#comment_list .icon_team{position:relative;bottom:1px;background-position:50%;background-size:100% auto;background-repeat:no-repeat;display:inline-block;height:16px;width:16px}#comment_list .user_info .commend{position:relative;top:1px;margin:0;height:20px;line-height:20px;vertical-align:middle;font-size:12px;color:#8c9399;float:right}#comment_list .user_info .commend span{position:relative;bottom:3px;background-image:url(" + __webpack_require__(553) + ");background-position:50%;background-size:100% auto;background-repeat:no-repeat;display:inline-block;height:24px;width:24px}#comment_list .user_info .commend .hot{background-image:url(" + __webpack_require__(554) + ");background-position:50%;background-size:100% auto;background-repeat:no-repeat}#comment_list .detail{margin:8px 0 12px;font-size:16px;color:#333}#comment_list .detail .text_con{line-height:24px;margin:0;word-break:break-word}#comment_list .detail .pic_con{margin-top:4px}#comment_list .detail .pic_con .img_con{display:inline-block;position:relative;overflow:hidden}#comment_list .pic_con img{width:100%;border-radius:2px}#comment_list .pic_con .single{max-height:336px;width:73%}#comment_list .pic_con .multiple{width:32%}#comment_list .pic_con .multiple:not(:last-child){margin-right:2%}#comment_list img.face{position:relative;top:-1px;height:24px;width:auto;vertical-align:top}#comment_list .pic_con .media-holder{position:absolute;left:0;top:0;z-index:999;width:100%;height:100%;background:url(" + __webpack_require__(523) + ") no-repeat 50%;background-size:40px 40px}#comment_list .pic_con .media-label{position:absolute;top:0;left:0;background:url(" + __webpack_require__(555) + ") 0 0 no-repeat;width:20px;height:20px;background-size:100% 100%;text-indent:1000px}#comment_list .date{font-size:10px;color:#999;margin:0 0 0 38px}.more_comment{font-size:16px;text-align:center;margin:36px 0}.more_comment>a{color:#16b13a}.more_comment .no_comment{color:#b5bcc4;font-weight:400}.more_comment .message-icon{width:17px;vertical-align:middle;margin-right:9px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/comments.vue"],"names":[],"mappings":"AACA,UACE,SAAU,AACV,UAAW,AACX,UAAY,CACb,AACD,yBACE,qBAAsB,AACtB,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,gBAAkB,CACnB,AACD,gCACE,qBAAsB,AACtB,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,sBAAuB,AACvB,WAAY,AACZ,wBAA0B,CAC3B,AACD,cACE,cAAoB,AACpB,SAAW,CACZ,AACD,iBACE,gBAAiB,AACjB,kBAAmB,AACnB,eAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,+BAAiC,CAClC,AACD,qBACE,kBAAmB,AACnB,sBAAuB,AACvB,mBAAoB,AACpB,WAAY,AACZ,iBAAmB,CACpB,AACD,kCACE,kBAAmB,AACnB,UAAY,CACb,AACD,uBACE,SAAU,AACV,eAAgB,AAChB,qBAAuB,CACxB,AACD,4BACE,cAAe,AACf,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,iCACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,sBACE,kBAAmB,AACnB,QAAS,AACT,UAAW,AACX,YAAa,AACb,WAAY,AACZ,iBAAmB,CACpB,AACD,yBACE,gBAAiB,AACjB,eAAgB,AAChB,WAAY,AACZ,SAAW,CACZ,AACD,+BACE,kBAAmB,AACnB,cAAe,AACf,UAAY,CACb,AACD,gCACE,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,qBAAsB,AACtB,qBAAuB,CACxB,AACD,sBACE,oFAAqF,AACrF,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,qBAAsB,AACtB,YAAa,AACb,UAAY,CACb,AACD,2BACE,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,mBAAoB,AACpB,WAAe,AACf,iBAAmB,CACpB,AACD,yBACE,kBAAmB,AACnB,WAAY,AACZ,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,qBAAsB,AACtB,YAAa,AACb,UAAY,CACb,AACD,kCACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,YAAa,AACb,iBAAkB,AAClB,sBAAuB,AACvB,eAAgB,AAChB,cAAe,AACf,WAAa,CACd,AACD,uCACE,kBAAmB,AACnB,WAAY,AACZ,+CAAoD,AACpD,wBAAmC,AACnC,0BAA2B,AAC3B,4BAA6B,AAC7B,qBAAsB,AACtB,YAAa,AACb,UAAY,CACb,AACD,uCACE,+CAAoD,AACpD,wBAAmC,AACnC,0BAA2B,AAC3B,2BAA6B,CAC9B,AACD,sBACE,kBAAmB,AACnB,eAAgB,AAChB,UAAY,CACb,AACD,gCACE,iBAAkB,AAClB,SAAU,AACV,qBAAuB,CACxB,AACD,+BACE,cAAgB,CACjB,AACD,wCACE,qBAAsB,AACtB,kBAAmB,AACnB,eAAiB,CAClB,AACD,2BACE,WAAY,AACZ,iBAAmB,CACpB,AACD,+BACE,iBAAkB,AAClB,SAAW,CACZ,AACD,iCACE,SAAW,CACZ,AACD,kDACE,eAAiB,CAClB,AACD,uBACE,kBAAmB,AACnB,SAAU,AACV,YAAa,AACb,WAAY,AACZ,kBAAoB,CACrB,AACD,qCACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,YAAa,AACb,WAAY,AACZ,YAAa,AACb,uDAAkE,AAClE,yBAA2B,CAC5B,AACD,oCACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,uDAA0D,AAC1D,WAAY,AACZ,YAAa,AACb,0BAA2B,AAC3B,kBAAoB,CACrB,AACD,oBACE,eAAgB,AAChB,WAAe,AACf,iBAAmB,CACpB,AACD,cACE,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CAChB,AACD,gBACE,aAAe,CAChB,AACD,0BACE,cAAe,AACf,eAAiB,CAClB,AACD,4BACE,WAAY,AACZ,sBAAuB,AACvB,gBAAkB,CACnB","file":"comments.vue","sourcesContent":["\n.comments {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n.comments .sub_line span {\n  display: inline-block;\n  height: 20px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #2d2f32;\n  line-height: 20px;\n}\n.comments .sub_line span:before {\n  display: inline-block;\n  height: 24px;\n  width: 3px;\n  margin-right: 12px;\n  vertical-align: middle;\n  content: \"\";\n  background-color: #16b13a;\n}\n#comment_list {\n  margin: 18px 0 18px;\n  padding: 0;\n}\n#comment_list li {\n  list-style: none;\n  position: relative;\n  padding: 0 15px 0 15px;\n  margin-bottom: 12px;\n  overflow: hidden;\n  border-bottom: solid #eff1f4 1px;\n}\n#comment_list .quote {\n  margin: 14px 0 6px;\n  padding: 10px 12px 8px;\n  background: #eff1f4;\n  color: #999;\n  border-radius: 3px;\n}\n#comment_list .quote .icon_author {\n  position: relative;\n  bottom: 1px;\n}\n#comment_list .quote p {\n  margin: 0;\n  font-size: 14px;\n  word-break: break-word;\n}\n#comment_list .quote_author {\n  color: #2d2f32;\n  font-size: 14px;\n  height: 16px;\n  line-height: 16px;\n  margin-bottom: 4px;\n}\n#comment_list .quote_author span {\n  display: inline-block;\n  vertical-align: middle;\n}\n#comment_list .avatar {\n  position: absolute;\n  top: 4px;\n  left: 15px;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n}\n#comment_list .user_info {\n  margin-bottom: 0;\n  font-size: 14px;\n  width: 100%;\n  padding: 0;\n}\n#comment_list .user_info .name {\n  margin: 0 0 0 38px;\n  color: #16b13a;\n  float: left;\n}\n#comment_list .user_info p span {\n  height: 20px;\n  line-height: 20px;\n  font-size: 12px;\n  display: inline-block;\n  vertical-align: middle;\n}\n#comment_list .icon_v {\n  background-image: url(https://static1.dongqiudi.com/web-new/static/img/V_con_v2.png);\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  display: inline-block;\n  height: 13px;\n  width: 13px;\n}\n#comment_list .icon_author {\n  height: 16px;\n  line-height: 16px;\n  margin-left: 4px;\n  font-size: 12px;\n  padding: 0 4px;\n  background: #16ac3a;\n  color: #ffffff;\n  border-radius: 4px;\n}\n#comment_list .icon_team {\n  position: relative;\n  bottom: 1px;\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  display: inline-block;\n  height: 16px;\n  width: 16px;\n}\n#comment_list .user_info .commend {\n  position: relative;\n  top: 1px;\n  margin: 0;\n  height: 20px;\n  line-height: 20px;\n  vertical-align: middle;\n  font-size: 12px;\n  color: #8c9399;\n  float: right;\n}\n#comment_list .user_info .commend span {\n  position: relative;\n  bottom: 3px;\n  background-image: url(../assets/icon_agree_def.png);\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n  display: inline-block;\n  height: 24px;\n  width: 24px;\n}\n#comment_list .user_info .commend .hot {\n  background-image: url(../assets/icon_agree_hot.png);\n  background-position: center center;\n  background-size: 100% auto;\n  background-repeat: no-repeat;\n}\n#comment_list .detail {\n  margin: 8px 0 12px;\n  font-size: 16px;\n  color: #333;\n}\n#comment_list .detail .text_con {\n  line-height: 24px;\n  margin: 0;\n  word-break: break-word;\n}\n#comment_list .detail .pic_con {\n  margin-top: 4px;\n}\n#comment_list .detail .pic_con .img_con {\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n#comment_list .pic_con img {\n  width: 100%;\n  border-radius: 2px;\n}\n#comment_list .pic_con .single {\n  max-height: 336px;\n  width: 73%;\n}\n#comment_list .pic_con .multiple {\n  width: 32%;\n}\n#comment_list .pic_con .multiple:not(:last-child) {\n  margin-right: 2%;\n}\n#comment_list img.face {\n  position: relative;\n  top: -1px;\n  height: 24px;\n  width: auto;\n  vertical-align: top;\n}\n#comment_list .pic_con .media-holder {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 999;\n  width: 100%;\n  height: 100%;\n  background: url(../assets/play@80x80.png) no-repeat center center;\n  background-size: 40px 40px;\n}\n#comment_list .pic_con .media-label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: url(../assets/gif_comments.png) 0 0 no-repeat;\n  width: 20px;\n  height: 20px;\n  background-size: 100% 100%;\n  text-indent: 1000px;\n}\n#comment_list .date {\n  font-size: 10px;\n  color: #999999;\n  margin: 0 0 0 38px;\n}\n.more_comment {\n  font-size: 16px;\n  text-align: center;\n  margin: 36px 0;\n}\n.more_comment > a {\n  color: #16b13a;\n}\n.more_comment .no_comment {\n  color: #b5bcc4;\n  font-weight: 400;\n}\n.more_comment .message-icon {\n  width: 17px;\n  vertical-align: middle;\n  margin-right: 9px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'comments',
    props: ['articleId', 'time'],
    data: function data() {
        return {
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL,
            componentsShow: false,
            comments: [],
            type: 'normal',
            article_id: this.articleId,
            loadComments: false
        };
    },

    methods: {
        init: function init() {
            var that = this;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/m/archives/recommend_comments/' + this.article_id + '?plat=m').then(function (response) {
                that.type = response.data.type;
                if (response.data.comments && response.data.comments.length > 0) {
                    that.loadComments = true;
                } else {
                    return;
                }
                for (var i = 0; i < response.data.comments.length; i++) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(that.comments, i, response.data.comments[i]);
                }
            }, function (error) {});
        },
        formatDate: function formatDate(gmtDate) {
            Date.prototype.Format = function (fmt) {
                var o = {
                    'M+': this.getMonth() + 1,
                    'd+': this.getDate(),
                    'h+': this.getHours(),
                    'm+': this.getMinutes(),
                    's+': this.getSeconds(),
                    'q+': Math.floor((this.getMonth() + 3) / 3),
                    'S': this.getMilliseconds() };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
                for (var k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
                }return fmt;
            };
            var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
            var diff_min = new Date().getTimezoneOffset();
            var local_date = new Date(date - diff_min * 60 * 1000);
            var same_year = local_date.getFullYear() === new Date().getFullYear();
            return local_date.Format(same_year ? 'MM-dd hh:mm' : 'yyyy-MM-dd hh:mm');
        }
    },
    mounted: function mounted() {
        this.init();
    }
});

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadComments) ? _c('div', {
    staticClass: "comments"
  }, [_c('div', {
    staticClass: "sub_line"
  }, [(_vm.type === 'recommend') ? _c('span', [_vm._v("Hot comments")]) : _c('span', [_vm._v("Latest comments")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "comment_list"
    }
  }, _vm._l((_vm.comments), function(com) {
    return _c('li', [_c('img', {
      staticClass: "avatar",
      attrs: {
        "alt": "avatar",
        "src": _vm.getImgSrc(com.user.avatar),
        "onerror": "javascript:this.src='https://img1.dongqiudi.com/fastdfs1/M00/3B/EF/o4YBAFjM9lqAel9GAAAQrsgeQ3A103.jpg'"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_info"
    }, [_c('p', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(com.user.username))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((com.user.medal_id != 0)),
        expression: "(com.user.medal_id!=0)"
      }],
      staticClass: "icon_v"
    }), _vm._v(" "), (com.user.team_icon) ? _c('span', {
      staticClass: "icon_team",
      style: ({
        backgroundImage: 'url(' + _vm.getImgSrc(com.user.team_icon) + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.user.is_root),
        expression: "com.user.is_root"
      }],
      staticClass: "icon_author"
    }, [_vm._v("author")])]), _vm._v(" "), _c('p', {
      staticClass: "commend"
    }, [_vm._v("\n                    " + _vm._s(com.up) + "\n                    "), _c('span', {
      class: {
        hot: _vm.type === 'recommend'
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(com.created_at)))]), _vm._v(" "), (com.quote) ? _c('div', {
      staticClass: "quote"
    }, [_c('div', {
      staticClass: "quote_author"
    }, [_c('span', [_vm._v(_vm._s(com.quote.user.username))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((com.quote.user.medal_id != 0)),
        expression: "(com.quote.user.medal_id!=0)"
      }],
      staticClass: "icon_v"
    }), _vm._v(" "), (com.quote.user.team_icon) ? _c('span', {
      staticClass: "icon_team",
      style: ({
        backgroundImage: 'url(' + _vm.getImgSrc(com.quote.user.team_icon) + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (com.quote.user.is_root),
        expression: "com.quote.user.is_root"
      }],
      staticClass: "icon_author"
    }, [_vm._v("author")])]), _vm._v(" "), _c('p', {
      staticClass: "quote_con",
      domProps: {
        "innerHTML": _vm._s(com.quote.content)
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "detail"
    }, [_c('p', {
      staticClass: "text_con",
      domProps: {
        "innerHTML": _vm._s(com.content)
      }
    }), _vm._v(" "), ((_vm.imgMode = 'on')) ? _c('div', {
      staticClass: "pic_con"
    }, _vm._l((com.attachments), function(pic) {
      return _c('div', {
        staticClass: "img_con",
        class: (com.attachments_total > 1) ? 'multiple' : 'single'
      }, [_c('img', {
        attrs: {
          "src": _vm.getImgSrc(pic.thumb)
        }
      }), _vm._v(" "), (pic.mime === 'image/gif') ? [_c('div', {
        staticClass: "media-holder"
      }), _vm._v(" "), _c('div', {
        staticClass: "media-label"
      })] : _vm._e()], 2)
    })) : _c('div', [_vm._v("\n                    [images]\n                ")])])])
  })), _vm._v(" "), (_vm.isInApp) ? _c('div', {
    staticClass: "more_comment"
  }, [(_vm.comments.length > 0) ? _c('a', {
    attrs: {
      "href": 'allfootball:///comment/' + _vm.article_id
    }
  }, [_c('img', {
    staticClass: "message-icon",
    attrs: {
      "src": __webpack_require__(556),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.$t('readMore')) + " >\n        ")]) : _c('a', {
    staticClass: "no_comment",
    attrs: {
      "href": 'allfootball:///post_comments/' + _vm.article_id
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('noCommented')) + "\n        ")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(326);
var hiddenKeys = __webpack_require__(135).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(708);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("3d38b7f2", content, true);

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".operamini-tips[data-v-c650d308]{background:#ff0;text-align:center;font-weight:700}.links[data-v-c650d308]{font-size:14px;padding:0 15px;color:#fff}.links a[data-v-c650d308]{color:#fff}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/pages/AppNews.vue"],"names":[],"mappings":"AACA,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB,AACD,wBACE,eAAgB,AAChB,eAAuB,AACvB,UAAY,CACb,AACD,0BACE,UAAY,CACb","file":"AppNews.vue","sourcesContent":["\n.operamini-tips[data-v-c650d308] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n.links[data-v-c650d308] {\n  font-size: 14px;\n  padding: 0 15px 0 15px;\n  color: #fff;\n}\n.links a[data-v-c650d308] {\n  color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_downloadFooter_vue__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_downloadFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_downloadFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_headerTitle_vue__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_headerTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_headerTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_articleCon_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_articleCon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_articleCon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_infos_vue__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_infos_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_infos_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_relatedNews_vue__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_relatedNews_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_relatedNews_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_comments_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_comments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_comments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_downloadPopup_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_downloadPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_downloadPopup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            imgMode: 'loading',
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL,
            title: '',
            time: '',
            writer: '',
            copyright: '',
            new_video_detail: 0,
            con: [],
            infos: {
                channels: [],
                column: {}
            },

            article_id: parseInt(this.$route.params.id, 10),
            bodyLoad: false,
            tag: [],
            loadItem: false,
            isOperamini: false
        };
    },

    computed: {
        articleBody: function articleBody() {
            return this.$store.state.articlebody[this.article_id] || {};
        },
        relative: function relative() {
            return this.$store.state.relative[this.article_id];
        },
        comments: function comments() {
            return this.$store.state.comments[this.article_id];
        }
    },
    asyncData: function asyncData(_ref) {
        var store = _ref.store,
            id = _ref.route.params.id;

        if (id) {
            return store.dispatch('FETCH_ARTICLEBODY', { article_id: id });
        } else {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
        }
    },
    head: function head() {
        var query = this.$route.query || {};
        var HOST =  true ? 'https://m.allfootballapp.com' : 'https://test-m.allfootballapp.com';
        var title = this.articleBody.title + '| All Football';
        var articleId = this.articleBody.article_id;
        var match = this.articleBody.body && this.articleBody.body.match(/<img[^>]+data-src\="([^"]+)"/);
        var p1 = this.articleBody.body && this.articleBody.body.match(/<(.*?)>(.*?)<\/\1>/);
        var shareUrl = HOST + this.$route.fullPath;
        var shareImg = match && match[1] ? match[1] : 'http://img.allfootballapp.com/www/M00/52/A6/rB8CLF1hHy2AWL55AAm0BGPys88585.png';
        var description = p1 && p1[2] ? p1[2] : 'Visit All Football to get football news, live scores, highlights, videos and commentary for EPL, La Liga, Bundesliga, Serie A';
        var keywords = 'All Football';

        if (this.articleBody.infos && this.articleBody.infos.channels) {
            keywords = this.articleBody.infos.channels.map(function (item) {
                return item.tag;
            }).join(',');
        }
        var link = [];
        if (this.$route.fullPath && this.$route.fullPath.indexOf('/news' === 0)) {
            link.push({
                rel: 'amphtml',
                href: HOST + '/amp' + this.$route.fullPath
            });
        }

        if (articleId) {
            link.push({
                vmid: 'canonical',
                rel: 'canonical',
                href: 'https://www.allfootballapp.com/articles/' + articleId
            });
        }

        return {
            title: title,
            link: link,
            meta: [{
                name: 'description',
                content: description.replace(/<(.*?)>/g, '')
            }, {
                name: 'keywords',
                content: keywords
            }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@allfootballapp' }, { name: 'twitter:creator', content: '@allfootballapp' }, { name: 'twitter:app:id:ipad', content: '' }, { name: 'twitter:title', content: title }, { name: 'twitter:description', content: title }, { name: 'twitter:image', content: shareImg }, { name: 'fb:app_id', content: 'summary_large_image' }, { name: 'og:url', content: shareUrl }, { name: 'og:type', content: 'article' }, { name: 'og:title', content: title }, { name: 'og:description', content: title }, { name: 'og:image', content: shareImg }, { name: 'og:site_name', content: 'AllfootballOfficial' }]
        };
    },

    created: function created() {},
    mounted: function mounted() {
        var query = this.$route.query || {};
        if (window.history && query.type && query.type === 'share') {
            var fullPath = this.$route.fullPath;
            history.replaceState(null, 'share', '/home?utm_source=APP_SHARE');
            history.pushState(null, 'share', fullPath);

            window.addEventListener('popstate', function (event) {
                if (location.pathname !== '/news') {
                    location.reload();
                }
            });
        }

        var mainwrap = document.getElementById('mainwrap');
        console.log('页面高度：' + mainwrap.offsetHeight);

        if (!this.articleBody) return;

        this.bodyLoad = true;

        if (!this.articleBody.infos) return;

        var channels = this.articleBody.infos.channels;
        for (var i = 0, len = channels.length; i < len; i++) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.infos.channels, i, channels[i]);
        }
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.infos, 'column', this.articleBody.infos.column);

        if (mainwrap.offsetHeight - window.screen.height - 100 > 0) {
            this.loadItem = false;
            window.addEventListener('scroll', this.loadmoreFn, false);
        } else {
            this.loadItem = true;
        }
        var utilObj = __webpack_require__(500);
        utilObj.timeForInOut();
        this.isOperamini = false;
    },
    methods: {
        loadmoreFn: function loadmoreFn() {
            if ((document.documentElement.scrollTop || document.body.scrollTop) > 10) {
                if (this.loadItem) return;
                this.loadItem = true;
                window.removeEventListener('scroll', this.loadmoreFn, false);
            }
        }
    },
    components: {
        downloadHeader: __WEBPACK_IMPORTED_MODULE_2__components_downloadHeader_vue___default.a, downloadFooter: __WEBPACK_IMPORTED_MODULE_3__components_downloadFooter_vue___default.a, headerTitle: __WEBPACK_IMPORTED_MODULE_4__components_headerTitle_vue___default.a, articleCon: __WEBPACK_IMPORTED_MODULE_5__components_articleCon_vue___default.a, infos: __WEBPACK_IMPORTED_MODULE_6__components_infos_vue___default.a, relatedNews: __WEBPACK_IMPORTED_MODULE_7__components_relatedNews_vue___default.a, comments: __WEBPACK_IMPORTED_MODULE_8__components_comments_vue___default.a, downloadPopup: __WEBPACK_IMPORTED_MODULE_9__components_downloadPopup_vue___default.a
    }
});

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(714),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05d89b0f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(712);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("bdc5a7fa", content, true);

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".clearfix[data-v-05d89b0f]:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.clearfix[data-v-05d89b0f]{*zoom:1}.clear[data-v-05d89b0f]{clear:both}.navBread[data-v-05d89b0f]{width:100%;height:2.4rem;background:#16b13a;color:#fff;line-height:2.4rem}.navBread a[data-v-05d89b0f]{padding:0 1rem;text-decoration:none;color:#fff;font-size:.8rem}.navBread .match[data-v-05d89b0f]{font-size:1rem;border-right:1px solid #119730}header[data-v-05d89b0f]{margin:1rem 1rem 0}header h1[data-v-05d89b0f]{font-size:21px;font-weight:700;padding:0;margin:0;line-height:1.3}header h2[data-v-05d89b0f]{line-height:20px;font-size:14px;padding:5px 0 0;font-weight:400;margin:0;color:#8c9399}header time[data-v-05d89b0f]{font-size:14px;display:inline-block;padding:0;vertical-align:top}.afHao[data-v-05d89b0f]{margin-top:15px}.userInfor[data-v-05d89b0f]{float:left}.userInfor dt[data-v-05d89b0f]{float:left;width:30px;height:30px;display:inline-block;margin-right:6px}.userInfor dt img[data-v-05d89b0f]{width:100%;height:100%;display:block;border-radius:50%}.userInfor dd[data-v-05d89b0f]{float:left}.userInfor dd p[data-v-05d89b0f]{font-size:13px;color:#2d2f32;line-height:1.2}.afhTime[data-v-05d89b0f]{font-size:12px!important;color:#8c9399!important}.afh_follow[data-v-05d89b0f]{border-radius:2px;height:21px;margin-right:11px;font-size:12px;line-height:21px;color:#16b13a;text-align:center;display:block;float:right;padding:2px 11px;border:1px solid #16b13a}.grayWord[data-v-05d89b0f]{color:#8c9399!important;border:1px solid #8c9399!important}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/headerTitle.vue"],"names":[],"mappings":"AACA,iCACE,kBAAmB,AACnB,cAAe,AACf,YAAa,AACb,YAAa,AACb,WAAY,AACZ,QAAU,CACX,AACD,4BACE,MAAS,CACV,AACD,wBACE,UAAY,CACb,AACD,2BACE,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,kBAAoB,CACrB,AACD,6BACE,eAAgB,AAChB,qBAAsB,AACtB,WAAY,AACZ,eAAiB,CAClB,AACD,kCACE,eAAgB,AAChB,8BAAgC,CACjC,AAID,wBACE,kBAAoB,CACrB,AACD,2BACE,eAAgB,AAChB,gBAAiB,AACjB,UAAW,AACX,SAAU,AACV,eAAiB,CAClB,AACD,2BACE,iBAAkB,AAClB,eAAgB,AAChB,gBAAmB,AACnB,gBAAoB,AACpB,SAAU,AACV,aAAe,CAChB,AACD,6BACE,eAAgB,AAChB,qBAAsB,AACtB,UAAW,AACX,kBAAoB,CACrB,AACD,wBACE,eAAiB,CAClB,AACD,4BACE,UAAY,CACb,AACD,+BACE,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,qBAAsB,AACtB,gBAAkB,CACnB,AACD,mCACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,iBAAmB,CACpB,AACD,+BACE,UAAY,CACb,AACD,iCACE,eAAgB,AAChB,cAAe,AACf,eAAiB,CAClB,AACD,0BACE,yBAA2B,AAC3B,uBAA0B,CAC3B,AACD,6BACE,kBAAmB,AACnB,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,wBAA0B,CAC3B,AACD,2BACE,wBAA0B,AAC1B,kCAAqC,CACtC","file":"headerTitle.vue","sourcesContent":["\n.clearfix[data-v-05d89b0f]:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0;\n}\n.clearfix[data-v-05d89b0f] {\n  *zoom: 1;\n}\n.clear[data-v-05d89b0f] {\n  clear: both;\n}\n.navBread[data-v-05d89b0f] {\n  width: 100%;\n  height: 2.4rem;\n  background: #16b13a;\n  color: #fff;\n  line-height: 2.4rem;\n}\n.navBread a[data-v-05d89b0f] {\n  padding: 0 1rem;\n  text-decoration: none;\n  color: #fff;\n  font-size: .8rem;\n}\n.navBread .match[data-v-05d89b0f] {\n  font-size: 1rem;\n  border-right: 1px solid #119730;\n}\n/*    header {\n        margin: 15px 15px 15px 15px;\n    }*/\nheader[data-v-05d89b0f] {\n  margin: 1rem 1rem 0;\n}\nheader h1[data-v-05d89b0f] {\n  font-size: 21px;\n  font-weight: 700;\n  padding: 0;\n  margin: 0;\n  line-height: 1.3;\n}\nheader h2[data-v-05d89b0f] {\n  line-height: 20px;\n  font-size: 14px;\n  padding: 5px 0 0 0;\n  font-weight: normal;\n  margin: 0;\n  color: #8c9399;\n}\nheader time[data-v-05d89b0f] {\n  font-size: 14px;\n  display: inline-block;\n  padding: 0;\n  vertical-align: top;\n}\n.afHao[data-v-05d89b0f] {\n  margin-top: 15px;\n}\n.userInfor[data-v-05d89b0f] {\n  float: left;\n}\n.userInfor dt[data-v-05d89b0f] {\n  float: left;\n  width: 30px;\n  height: 30px;\n  display: inline-block;\n  margin-right: 6px;\n}\n.userInfor dt img[data-v-05d89b0f] {\n  width: 100%;\n  height: 100%;\n  display: block;\n  border-radius: 50%;\n}\n.userInfor dd[data-v-05d89b0f] {\n  float: left;\n}\n.userInfor dd p[data-v-05d89b0f] {\n  font-size: 13px;\n  color: #2d2f32;\n  line-height: 1.2;\n}\n.afhTime[data-v-05d89b0f] {\n  font-size: 12px !important;\n  color: #8c9399 !important;\n}\n.afh_follow[data-v-05d89b0f] {\n  border-radius: 2px;\n  height: 21px;\n  margin-right: 11px;\n  font-size: 12px;\n  line-height: 21px;\n  color: #16b13a;\n  text-align: center;\n  display: block;\n  float: right;\n  padding: 2px 11px;\n  border: 1px solid #16b13a;\n}\n.grayWord[data-v-05d89b0f] {\n  color: #8c9399 !important;\n  border: 1px solid #8c9399 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headerTitle',
    data: function data() {
        return {
            firstTitle: '',
            article_id: parseInt(this.$route.params.id, 10),
            subtitle: '',
            showNav: true
        };
    },
    props: ['title', 'time', 'writer', 'afhao'],
    computed: {
        jumpUrl: function jumpUrl() {
            if (this.firstTitle === 'News') {
                return '/news';
            } else if (this.firstTitle === 'Video') {
                return '/video';
            }
        },
        subJumpUrl: function subJumpUrl() {
            return this.jumpUrl + '/' + this.subtitle.replace(/\s/g, '-');
        }
    },
    created: function created() {
        console.log('000000', this.afhao);
        this.getNav();
        if ( false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL) {
            this.showNav = false;
        }
    },
    methods: {
        afhFollow: function afhFollow(afh_info) {
            console.log('-----666------', afh_info);

            if (Number(afh_info.follow_status) === 0) {
                afh_info.follow_status = 1;
            } else if (Number(afh_info.follow_status) === 1) {
                afh_info.follow_status = 0;
            }
        },

        getNav: function getNav() {
            var _this = this;

            if (this.$route.path.indexOf('/news/') >= 0) {
                this.firstTitle = 'News';
                if (this.$route.query.type === 'video') {
                    this.firstTitle = 'Video';
                }
            }
            this.subtitle = this.$route.params.subtitle || '';
            if (this.firstTitle && this.subtitle) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(global.apiDomain + '/m/v2/article/menu/' + this.article_id + '?plat=m').then(function (response) {
                if (response.data.length > 0) {
                    var data = response.data[0];
                    _this.firstTitle = data['menu'].label;
                    _this.subtitle = data['tab'].label;
                }
            }, function (error) {});
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "navBread"
  }, [_c('router-link', {
    staticClass: "match",
    attrs: {
      "to": {
        path: _vm.jumpUrl
      }
    }
  }, [_vm._v(_vm._s(_vm.firstTitle))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: _vm.subJumpUrl
      }
    }
  }, [_vm._v(_vm._s(_vm.subtitle))])], 1), _vm._v(" "), _c('header', {
    staticClass: "pad15"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', [(!_vm.afhao || _vm.afhao.length === 0 || JSON.stringify(_vm.afhao) === '{}') ? _c('h2', [_c('time', [_vm._v(_vm._s(_vm.time))]), _vm._v("\n                  /  "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.writer)
    }
  })]) : _c('div', {
    staticClass: "afHao clearfix"
  }, [_c('dl', {
    staticClass: "userInfor"
  }, [_c('dt', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.afhao.avatar)
    }
  })]), _vm._v(" "), _c('dd', [_c('p', [_vm._v(_vm._s(_vm.afhao.name))]), _vm._v(" "), _c('p', {
    staticClass: "afhTime"
  }, [_vm._v(_vm._s(_vm.time))])])]), _vm._v(" "), _c('a', {
    staticClass: "afh_follow",
    class: {
      'grayWord': Number(_vm.afhao.follow_status) === 1
    },
    on: {
      "click": function($event) {
        _vm.afhFollow(_vm.afhao)
      }
    }
  }, [_vm._v(_vm._s(Number(_vm.afhao.follow_status) === 0 ? _vm.$t('Follow') : _vm.$t('Following')))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(740),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(717);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("49427c68", content, true);

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".main article{margin:0 15px 15px;font-size:17px}article .download{text-align:center;display:block;margin:10px auto -20px;font-weight:700;text-decoration:underline}article p{line-height:30px;margin:22px 0;word-wrap:break-word}article .con{margin-top:20px}article h2,article h3{line-height:1.5;font-weight:600;margin:10px 0;padding:0 0 0 10px;position:relative;color:#333}article h2{font-size:19px}article h3{font-size:17px}article h2 .border,article h3 .border{height:6px;width:6px;border-radius:50%;display:block;position:absolute;top:9px;left:0;background:#16b13a}article img{display:block;margin:24px auto;width:100%;background:#efefef no-repeat 50%;background-size:118px}article img.data-gif-src{width:100%}article video{display:block;width:100%;margin:0;background:#3e3e3e no-repeat 50%;background-size:118px;border-radius:1px;-moz-border-radius:1px;-webkit-border-radius:1px}article a{color:#399e5c}.media-container{margin:0 auto}.img-container,.media-container{display:block;position:relative;z-index:1000}.img-container{margin:20px auto 10px;min-height:46px}.img-container.off{background:url(" + __webpack_require__(718) + ") 50% no-repeat #e9e9e9;background-size:auto 46px}.img-container.loading,.img-container.off{height:200px}.img-container.loading{z-index:1000;position:relative;background:url(" + __webpack_require__(548) + ") #e9e9e9 no-repeat 50%;background-size:20px 20px}.media-loader{background:url(" + __webpack_require__(548) + ") #e9e9e9 no-repeat 50%;opacity:.3;-webkit-opacity:.3;-moz-opacity:.3;background-size:20px 20px}.media-holder,.media-loader{position:absolute;left:0;top:0;z-index:999;width:100%;height:100%}.media-holder{background:url(" + __webpack_require__(523) + ") no-repeat 50%;background-size:40px 40px}.media-label{position:absolute;top:0;left:0;background:url(" + __webpack_require__(591) + ") 0 0 no-repeat;width:33px;height:33px;background-size:100% 100%;text-indent:1000px}.media-loading{background:url(" + __webpack_require__(548) + ") #e9e9e9 no-repeat 50%;filter:alpha(opacity=30);opacity:.3;background-size:20px 20px}.img-off-holder{width:100%;height:auto;text-align:center;display:table-cell;vertical-align:middle}article .video{position:relative}article .video .mask{width:100%;height:100%;position:absolute;top:0;left:0;background:url(" + __webpack_require__(592) + ") 50% no-repeat rgba(0,0,0,.5);background-size:auto 20px;z-index:10000;display:none}.media-container-video{background-repeat:no-repeat;background-position:50%;background-size:cover;background-color:rgba(0,0,0,.5);border-bottom:20px solid #000;border-top:20px solid #000;width:100%;background-image:url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_off_holder.png)}.media-holder-video{background:url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png) no-repeat 50%;background-size:48px auto}.fade-enter-active{transition:opacity 1.5s}.fade-enter{opacity:0}a.product_box:visited{color:#333}.audio{background-color:#fff;overflow:hidden;padding:4px;position:relative;margin:24px auto;border:1px solid #e9e9e9;height:40px}.audio a{width:40px;height:40px;float:right;margin-top:-43px}.audio a.play{background:url(" + __webpack_require__(593) + ") 50% no-repeat;background-size:12px}.audio a.pause{background:url(" + __webpack_require__(594) + ") 50% no-repeat;background-size:12px}.audio .main{padding-left:50px;background:url(" + __webpack_require__(595) + ") 0 0 no-repeat;background-size:40px 40px}.audio .main h3{height:24px;line-height:24px;font-size:14px;color:#2d2f32;font-weight:400;margin:0;padding:0}.audio .main p{height:20px;line-height:20px;font-size:12px;color:#8c9399;margin:0;padding:0}.audio .progress{position:absolute;height:2px;bottom:0;left:0;z-index:100;background:#55c818}.audio audio{position:absolute;display:none}.vote_box{position:relative;border:1px solid #eff1f4;margin:50px 0 35px}.vote_box h4{position:absolute;top:-37px;width:100%;line-height:20px;height:20px;left:0;text-align:center}.vote_box span{display:inline-block;font-size:16px;padding:0 10px;background:#fff;color:#2d2f32}.vote_box dl{margin:0;padding:0}.vote_box dt{line-height:20px;padding:20px 0 12px 12px;font-size:16px;color:#2d2f32;text-align:left}.vote .radio dt span{fonts-size:14px}.vote_box dd{padding:13px 10px 13px 40px;line-height:24px;border-top:1px solid #eff1f4;position:relative;font-size:16px;color:#2d2f32}.vote_box .re dd{padding:10px}.vote_box h3{color:#5b6463;line-height:20px;font-size:14px;margin:0 0 1px;padding:0 26px 0 0;position:relative;font-weight:400}.vote_box .re h3{color:#2d2f32}.vote_box h3 span{color:#2d2f32;position:absolute;bottom:8px;right:0;width:26px;text-align:right;height:14px;line-height:14px;left:auto;top:auto}.vote_box h3 em{color:#fff;background:#ff8d06;padding:0 3px;border-radius:2px;font-size:10px;line-height:16px;height:16px;display:inline-block;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;-webkit-transform:scale(.75);transform:scale(.75);font-style:normal;font-weight:400}.vote_box div.rank{width:100%;height:16px;line-height:16px;background:#eff1f4}.vote_box div.bar{background:#4ccf6c;height:16px;line-height:16px}.vote_box div.voted{background:#ff8d06}.vote_box dd span.tag{position:absolute;width:12px;line-height:20px;height:12px;border:1px solid #8dc99b;top:18px;left:15px;padding:0}.vote_box .checkbox span.tag{border-radius:5px}.vote_box .checkbox dd.checked span.tag{background:url(" + __webpack_require__(719) + ") 50% no-repeat;border:0;padding:1px;border-radius:0;background-size:100% 100%}.vote_box .radio span.tag{border-radius:20px}.vote_box .radio dd.checked span.tag{background:url(" + __webpack_require__(720) + ") 50% no-repeat;border:0;padding:1px;border-radius:0;background-size:100% 100%}.vote_box .text{padding:13px 0;text-align:center;line-height:21px;border-top:1px solid #ebebeb;font-size:15px}.vote_box .text p{text-align:center;margin:0;font-size:15px;color:#2d2f32}.vote_box .text span{display:inline-block;max-width:100px;height:20px;line-height:20px;overflow:hidden;text-overflow:ellipsis;vertical-align:top}.vote_box a.btn{display:block;width:90px;background:#16b13a;margin:0 auto;color:#fff;text-align:center;height:35px;font-size:15px;line-height:35px;padding:0;border-radius:3px;text-decoration:none}.tips{margin-top:-20px;color:#888}.tips,.tips_v{display:block;width:100%;font-size:.8em;line-height:1.5}.tips_v{color:#8c9399}.declare{margin:0;padding:0;color:gray;font-size:14px;width:100%;text-align:left}.declare a{color:#91989d;font-size:13px;margin:10px 0;display:block}.declare a:before{content:\"\";display:inline-block;background:url(" + __webpack_require__(721) + ") 50% no-repeat;background-size:12px auto;width:12px;margin-right:4px;height:15px;top:2px;position:relative}.afhaoBottom{margin:0;height:auto}.afhaoAbout{float:left;margin:0}.afhaoAbout img{width:14px;height:14px;border-radius:50%;display:inline-block;min-height:14px;background:none;margin-right:2px;position:relative;top:3px;margin:0 6px 0 0}.afhaoAbout span{font-size:12px;color:#91989d}.afhaoReport{float:right;margin:0}.afhaoReport img{width:14px;height:14px;border-radius:50%;display:inline-block;min-height:12px;background:none;margin-right:2px;position:relative;top:3px;margin:0}.afhaoReport span{font-size:12px;color:#91989d}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/articleCon.vue"],"names":[],"mappings":"AACA,cACI,mBAAyB,AACzB,cAAgB,CACnB,AACD,kBACI,kBAAmB,AACnB,cAAe,AACf,uBAAwB,AACxB,gBAAkB,AAClB,yBAA2B,CAC9B,AACD,UACI,iBAAkB,AAClB,cAAe,AACf,oBAAsB,CACzB,AACD,aACI,eAAiB,CACpB,AACD,sBACI,gBAAiB,AACjB,gBAAiB,AACjB,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,UAAY,CACf,AACD,WACI,cAAgB,CACnB,AACD,WACI,cAAgB,CACnB,AACD,sCACI,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,OAAQ,AACR,kBAAoB,CACvB,AACD,YACI,cAAe,AACf,iBAAkB,AAElB,WAAY,AACZ,iCAA4C,AAC5C,qBAAuB,CAC1B,AACD,yBACI,UAAW,CACd,AACD,cACI,cAAe,AACf,WAAY,AACZ,SAAU,AACV,iCAA4C,AAC5C,sBAAuB,AACvB,kBAAmB,AACnB,uBAAwB,AACxB,yBAA2B,CAC9B,AACD,UACI,aAAe,CAClB,AACD,iBAII,aAAe,CAClB,AACD,gCALI,cAAe,AACf,kBAAmB,AACnB,YAAc,CASjB,AAND,eAII,sBAAuB,AACvB,eAAiB,CACpB,AACD,mBACI,+DAA8E,AAC9E,yBAA2B,CAC9B,AACD,0CACI,YAAc,CACjB,AACD,uBACI,aAAc,AACd,kBAAmB,AACnB,+DAA8E,AAC9E,yBAA2B,CAC9B,AACD,cAOI,+DAA8E,AAC9E,WAAY,AACZ,mBAAoB,AACpB,gBAAiB,AACjB,yBAA2B,CAC9B,AACD,4BAZI,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,YAAa,AACb,WAAY,AACZ,WAAa,CAgBhB,AATD,cAOI,uDAAkE,AAClE,yBAA2B,CAC9B,AACD,aACI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,uDAAiD,AACjD,WAAY,AACZ,YAAa,AACb,0BAA2B,AAC3B,kBAAoB,CACvB,AACD,eACI,+DAA8E,AAC9E,yBAA0B,AAC1B,WAAa,AACb,yBAA2B,CAC9B,AACD,gBACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,qBAAuB,CAC1B,AACD,eACI,iBAAkB,CACrB,AACD,qBACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,sEAAuF,AACvF,0BAA2B,AAC3B,cAAe,AACf,YAAc,CACjB,AACD,uBACI,4BAA6B,AAC7B,wBAAmC,AACnC,sBAAuB,AACvB,gCAAqC,AACrC,8BAAkC,AAClC,2BAA+B,AAC/B,WAAY,AACZ,6GAA+G,CAClH,AACD,oBACI,gHAA2H,AAC3H,yBAA2B,CAC9B,AACD,mBACI,uBAAwB,CAC3B,AACD,YACI,SAAU,CACb,AACD,sBACI,UAAe,CAClB,AACD,OACI,sBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,yBAA0B,AAC1B,WAAa,CAChB,AACD,SACI,WAAY,AACZ,YAAa,AACb,YAAa,AACb,gBAAkB,CACrB,AACD,cACI,uDAAiE,AACjE,oBAAqB,CACxB,AACD,eACI,uDAAkE,AAClE,oBAAqB,CACxB,AACD,aACI,kBAAmB,AACnB,uDAAsD,AACtD,yBAA2B,CAC9B,AACD,gBACI,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,cAAe,AACf,gBAAiB,AACjB,SAAU,AACV,SAAW,CACd,AACD,eACI,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,cAAe,AACf,SAAU,AACV,SAAW,CACd,AACD,iBACI,kBAAmB,AACnB,WAAY,AACZ,SAAU,AACV,OAAQ,AACR,YAAa,AACb,kBAAoB,CACvB,AACD,aACI,kBAAmB,AACnB,YAAc,CACjB,AACD,UACI,kBAAmB,AACnB,yBAA0B,AAC1B,kBAAoB,CACvB,AACD,aACI,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,OAAQ,AACR,iBAAkB,CACrB,AACD,eACI,qBAAsB,AACtB,eAAgB,AAChB,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAClB,AACD,aACI,SAAU,AACV,SAAW,CACd,AACD,aACI,iBAAkB,AAClB,yBAA0B,AAC1B,eAAgB,AAChB,cAAe,AACf,eAAiB,CACpB,AACD,qBACI,eAAiB,CACpB,AACD,aACI,4BAA6B,AAC7B,iBAAkB,AAClB,6BAA8B,AAC9B,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAClB,AACD,iBACI,YAAc,CACjB,AACD,aACI,cAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,eAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,eAAiB,CACpB,AACD,iBACI,aAAe,CAClB,AACD,kBACI,cAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,iBAAkB,AAClB,UAAW,AACX,QAAU,CACb,AACD,gBACI,WAAY,AACZ,mBAAoB,AACpB,cAAe,AACf,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,qBAAsB,AACtB,6BAA8B,AAC9B,yBAA0B,AAC1B,6BAAmC,AACnC,qBAA2B,AAC3B,kBAAmB,AACnB,eAAoB,CACvB,AACD,mBACI,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,kBAAoB,CACvB,AACD,kBACI,mBAAoB,AACpB,YAAa,AACb,gBAAkB,CACrB,AACD,oBACI,kBAAoB,CACvB,AACD,sBACI,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,yBAA0B,AAC1B,SAAU,AACV,UAAW,AACX,SAAW,CACd,AACD,6BACI,iBAAmB,CACtB,AACD,wCACI,wDAAkE,AAClE,SAAU,AACV,YAAa,AACb,gBAAiB,AACjB,yBAA0B,CAC7B,AACD,0BACI,kBAAoB,CACvB,AACD,qCACI,wDAA+D,AAC/D,SAAU,AACV,YAAa,AACb,gBAAiB,AACjB,yBAA0B,CAC7B,AACD,gBACI,eAAgB,AAChB,kBAAmB,AACnB,iBAAkB,AAClB,6BAA8B,AAC9B,cAAgB,CACnB,AACD,kBACI,kBAAmB,AACnB,SAAU,AACV,eAAgB,AAChB,aAAe,CAClB,AACD,qBACI,qBAAsB,AACtB,gBAAiB,AACjB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,gBACI,cAAe,AACf,WAAY,AACZ,mBAAoB,AACpB,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,iBAAkB,AAClB,UAAW,AACX,kBAAmB,AACnB,oBAAsB,CACzB,AACD,MACI,iBAAkB,AAIlB,UAAe,CAElB,AACD,cANI,cAAe,AACf,WAAY,AACZ,eAAiB,AAEjB,eAAgB,CAQnB,AAND,QAII,aAAe,CAElB,AACD,SACI,SAAU,AACV,UAAW,AAGX,WAAe,AACf,eAAgB,AAChB,WAAY,AACZ,eAAiB,CALpB,AAOD,WACI,cAAe,AACf,eAAgB,AAChB,cAAe,AACf,aAAe,CAClB,AACD,kBACI,WAAY,AACZ,qBAAsB,AACtB,wDAAiE,AACjE,0BAA2B,AAC3B,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,QAAS,AACT,iBAAmB,CACtB,AACD,aACI,SAAU,AACV,WAAa,CAChB,AACD,YACI,WAAY,AACZ,QAAY,CACf,AACD,gBACI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,qBAAsB,AACtB,gBAAiB,AACjB,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AACnB,QAAS,AACT,gBAAkB,CACrB,AACD,iBACI,eAAgB,AAChB,aAAe,CAClB,AACD,aACI,YAAa,AACb,QAAU,CACb,AACD,iBAEI,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,qBAAsB,AACtB,gBAAiB,AACjB,gBAAiB,AACjB,iBAAkB,AAClB,kBAAmB,AACnB,QAAS,AACT,QAAU,CACb,AACD,kBACI,eAAgB,AAChB,aAAe,CAClB","file":"articleCon.vue","sourcesContent":["\n.main article {\n    margin: 0 15px 15px 15px;\n    font-size: 17px;\n}\narticle .download{\n    text-align: center;\n    display: block;\n    margin: 10px auto -20px;\n    font-weight: bold;\n    text-decoration: underline;\n}\narticle p {\n    line-height: 30px;\n    margin: 22px 0;\n    word-wrap: break-word;\n}\narticle .con {\n    margin-top: 20px;\n}\narticle h2, article h3 {\n    line-height: 1.5;\n    font-weight: 600;\n    margin: 10px 0;\n    padding: 0 0 0 10px;\n    position: relative;\n    color: #333;\n}\narticle h2 {\n    font-size: 19px;\n}\narticle h3 {\n    font-size: 17px;\n}\narticle h2 .border, article h3 .border {\n    height: 6px;\n    width: 6px;\n    border-radius: 50%;\n    display: block;\n    position: absolute;\n    top: 9px;\n    left: 0;\n    background: #16b13a;\n}\narticle img {\n    display: block;\n    margin: 24px auto;\n    /*max-width: 100%!important;*/\n    width: 100%;\n    background: #efefef no-repeat center center;\n    background-size: 118px;\n}\narticle img.data-gif-src {\n    width: 100%\n}\narticle video {\n    display: block;\n    width: 100%;\n    margin: 0;\n    background: #3e3e3e no-repeat center center;\n    background-size: 118px;\n    border-radius: 1px;\n    -moz-border-radius: 1px;\n    -webkit-border-radius: 1px;\n}\narticle a {\n    color: #399e5c;\n}\n.media-container {\n    display: block;\n    position: relative;\n    z-index: 1000;\n    margin: 0 auto;\n}\n.img-container {\n    display: block;\n    position: relative;\n    z-index: 1000;\n    margin: 20px auto 10px;\n    min-height: 46px;\n}\n.img-container.off {\n    background: url(../assets/img_holder_off.png) center center no-repeat #e9e9e9;\n    background-size: auto 46px;\n}\n.img-container.off, .img-container.loading {\n    height: 200px;\n}\n.img-container.loading {\n    z-index: 1000;\n    position: relative;\n    background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;\n    background-size: 20px 20px;\n}\n.media-loader {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 999;\n    width: 100%;\n    height: 100%;\n    background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;\n    opacity: .3;\n    -webkit-opacity: .3;\n    -moz-opacity: .3;\n    background-size: 20px 20px;\n}\n.media-holder {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 999;\n    width: 100%;\n    height: 100%;\n    background: url(../assets/play@80x80.png) no-repeat center center;\n    background-size: 40px 40px;\n}\n.media-label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: url(../assets/gif.png) 0 0 no-repeat;\n    width: 33px;\n    height: 33px;\n    background-size: 100% 100%;\n    text-indent: 1000px;\n}\n.media-loading {\n    background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;\n    filter: alpha(opacity=30);\n    opacity: 0.3;\n    background-size: 20px 20px;\n}\n.img-off-holder {\n    width: 100%;\n    height: auto;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n}\narticle .video {\n    position: relative\n}\narticle .video .mask {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: url(../assets/icon_playing.png) center center no-repeat rgba(0, 0, 0, 0.5);\n    background-size: auto 20px;\n    z-index: 10000;\n    display: none;\n}\n.media-container-video {\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: cover;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-bottom: 20px solid #000000;\n    border-top: 20px solid #000000;\n    width: 100%;\n    background-image: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_off_holder.png);\n}\n.media-holder-video {\n    background: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png) no-repeat center center;\n    background-size: 48px auto;\n}\n.fade-enter-active {\n    transition: opacity 1.5s\n}\n.fade-enter {\n    opacity: 0\n}\na.product_box:visited {\n    color: #333333;\n}\n.audio {\n    background-color: #ffffff;\n    overflow: hidden;\n    padding: 4px;\n    position: relative;;\n    margin: 24px auto;\n    border: 1px solid #e9e9e9;\n    height: 40px;\n}\n.audio a {\n    width: 40px;\n    height: 40px;\n    float: right;\n    margin-top: -43px;\n}\n.audio a.play {\n    background: url(../assets/icon_play.png) center center no-repeat;\n    background-size: 12px\n}\n.audio a.pause {\n    background: url(../assets/icon_pause.png) center center no-repeat;\n    background-size: 12px\n}\n.audio .main {\n    padding-left: 50px;\n    background: url(../assets/bg_music.png) 0 0 no-repeat;\n    background-size: 40px 40px;\n}\n.audio .main h3 {\n    height: 24px;\n    line-height: 24px;\n    font-size: 14px;\n    color: #2d2f32;\n    font-weight: 400;\n    margin: 0;\n    padding: 0;\n}\n.audio .main p {\n    height: 20px;\n    line-height: 20px;\n    font-size: 12px;\n    color: #8c9399;\n    margin: 0;\n    padding: 0;\n}\n.audio .progress {\n    position: absolute;\n    height: 2px;\n    bottom: 0;\n    left: 0;\n    z-index: 100;\n    background: #55c818;\n}\n.audio audio {\n    position: absolute;\n    display: none;\n}\n.vote_box {\n    position: relative;\n    border: 1px solid #eff1f4;\n    margin: 50px 0 35px;\n}\n.vote_box h4 {\n    position: absolute;\n    top: -37px;\n    width: 100%;\n    line-height: 20px;\n    height: 20px;\n    left: 0;\n    text-align: center\n}\n.vote_box span {\n    display: inline-block;\n    font-size: 16px;\n    padding: 0 10px;\n    background: #fff;\n    color: #2d2f32;\n}\n.vote_box dl {\n    margin: 0;\n    padding: 0;\n}\n.vote_box dt {\n    line-height: 20px;\n    padding: 20px 0 12px 12px;\n    font-size: 16px;\n    color: #2d2f32;\n    text-align: left;\n}\n.vote .radio dt span {\n    fonts-size: 14px;\n}\n.vote_box dd {\n    padding: 13px 10px 13px 40px;\n    line-height: 24px;\n    border-top: 1px solid #eff1f4;\n    position: relative;\n    font-size: 16px;\n    color: #2d2f32;\n}\n.vote_box .re dd {\n    padding: 10px;\n}\n.vote_box h3 {\n    color: #5b6463;\n    line-height: 20px;\n    font-size: 14px;\n    margin: 0 0 1px 0;\n    padding: 0 26px 0 0;;\n    position: relative;\n    font-weight: 400;\n}\n.vote_box .re h3 {\n    color: #2d2f32;\n}\n.vote_box h3 span {\n    color: #2d2f32;\n    position: absolute;\n    bottom: 8px;\n    right: 0;\n    width: 26px;\n    text-align: right;\n    height: 14px;\n    line-height: 14px;\n    left: auto;\n    top: auto;\n}\n.vote_box h3 em {\n    color: #fff;\n    background: #ff8d06;\n    padding: 0 3px;\n    border-radius: 2px;\n    font-size: 10px;\n    line-height: 16px;\n    height: 16px;\n    display: inline-block;\n    -webkit-transform-origin: 0 0;\n    -ms-transform-origin: 0 0;\n    -webkit-transform: scale(.75, .75);\n    transform: scale(.75, .75);\n    font-style: normal;\n    font-weight: normal;\n}\n.vote_box div.rank {\n    width: 100%;\n    height: 16px;\n    line-height: 16px;\n    background: #eff1f4;\n}\n.vote_box div.bar {\n    background: #4ccf6c;\n    height: 16px;\n    line-height: 16px;\n}\n.vote_box div.voted {\n    background: #ff8d06;\n}\n.vote_box dd span.tag {\n    position: absolute;\n    width: 12px;\n    line-height: 20px;\n    height: 12px;\n    border: 1px solid #8dc99b;\n    top: 18px;\n    left: 15px;\n    padding: 0;\n}\n.vote_box .checkbox span.tag {\n    border-radius: 5px;\n}\n.vote_box .checkbox dd.checked span.tag {\n    background: url(../assets/poll_check.png) center center no-repeat;\n    border: 0;\n    padding: 1px;\n    border-radius: 0;\n    background-size: 100% 100%\n}\n.vote_box .radio span.tag {\n    border-radius: 20px;\n}\n.vote_box .radio dd.checked span.tag {\n    background: url(../assets/check_r.png) center center no-repeat;\n    border: 0;\n    padding: 1px;\n    border-radius: 0;\n    background-size: 100% 100%\n}\n.vote_box .text {\n    padding: 13px 0;\n    text-align: center;\n    line-height: 21px;\n    border-top: 1px solid #ebebeb;\n    font-size: 15px;\n}\n.vote_box .text p {\n    text-align: center;\n    margin: 0;\n    font-size: 15px;\n    color: #2d2f32;\n}\n.vote_box .text span {\n    display: inline-block;\n    max-width: 100px;\n    height: 20px;\n    line-height: 20px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n}\n.vote_box a.btn {\n    display: block;\n    width: 90px;\n    background: #16b13a;\n    margin: 0 auto;\n    color: #fff;\n    text-align: center;\n    height: 35px;\n    font-size: 15px;\n    line-height: 35px;\n    padding: 0;\n    border-radius: 3px;\n    text-decoration: none;\n}\n.tips {\n    margin-top: -20px;\n    display: block;\n    width: 100%;\n    font-size: 0.8em;\n    color: #888888;\n    line-height: 1.5\n}\n.tips_v {\n    display: block;\n    width: 100%;\n    font-size: 0.8em;\n    color: #8c9399;\n    line-height: 1.5\n}\n.declare {\n    margin: 0;\n    padding: 0;\n}\n.declare {\n    color: #808080;\n    font-size: 14px;\n    width: 100%;\n    text-align: left;\n}\n.declare a {\n    color: #91989d;\n    font-size: 13px;\n    margin: 10px 0;\n    display: block;\n}\n.declare a:before {\n    content: \"\";\n    display: inline-block;\n    background: url(../assets/copyright.png) center center no-repeat;\n    background-size: 12px auto;\n    width: 12px;\n    margin-right: 4px;\n    height: 15px;\n    top: 2px;\n    position: relative;\n}\n.afhaoBottom {\n    margin: 0;\n    height: auto;\n}\n.afhaoAbout {\n    float: left;\n    margin: 0px;\n}\n.afhaoAbout img {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    display: inline-block;\n    min-height: 14px;\n    background: none;\n    margin-right: 2px;\n    position: relative;\n    top: 3px;\n    margin: 0 6px 0 0;\n}\n.afhaoAbout span {\n    font-size: 12px;\n    color: #91989d;\n}\n.afhaoReport {\n    float: right;\n    margin: 0;\n}\n.afhaoReport img {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    display: inline-block;\n    min-height: 12px;\n    background: none;\n    margin-right: 2px;\n    position: relative;\n    top: 3px;\n    margin: 0;\n}\n.afhaoReport span {\n    font-size: 12px;\n    color: #91989d;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_holder_off.5467eac.png";

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAG1BMVEUAAAAWrDoWrDoWrDoWrDoWrDoWrDoWrDoWrDrCpT87AAAACHRSTlMA+VJIXerl3Sm9vBYAAABkSURBVCjPYxhWQC0YU4xFoh1T0LGjHYvCDmEsChsNqKFQtRiLwohGBUwTIzqEME1U7GhUwLCaSQKsFKEQoRShEKEUphBVKUQhmlKIQjSlYIXoSsEK0ZWCFGIoBSrEjK9khmECABBQIJGYQTE8AAAAAElFTkSuQmCC"

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAATlBMVEX///9Mz2xU0nP7/vzT9Nxc1Hmh5rHl+Op93JT1/feB3pht2Idm14Ji1X7v+/LJ8dPB7syo6Ldw2Yrn+eyd5a7P8tiQ4qRNz23b9uKK4J84PInpAAABNElEQVQ4y41U15KDMAzUyrZsMA6hhfD/P3q55Fw4M5B9YEDsqKwKFVBaXGBwcLIoOsJNDDKM3CqGGhjo5t421Nh+7gAe/vmyHmh1YdAO8JZKC6PTtMcSwHpHaZsqfOMKkmU86ABqA9u/V4/2uFTl4D9/BnQxUBUuYHjrwmuMWmMB/+okaLPt3hqY9p4NDvKKaZDcTCM+GKdUMox6PbpEMbkVidRBk2COnyMyxmicIeTQx1xQIubUw1GATemVcFFgBGJEcQxKmKgjmIAYGTtwNn/j5zKfCeGbui71EUipsy10TmPqoXf9sqlfifKEUXXfedf3DfKen+SoxnPl28UcKo/hYp7pAa/O94JmsD3fL/UA6/M91T5S8r6vu31/biu8Pbob0k8NNVMvPt6N6/tTQy3Hd+wH6kYLMBjw/iUAAAAASUVORK5CYII="

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAPFBMVEUAAACRmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ0nj+SuAAAAE3RSTlMACu/bl4pHz1y3HuZrck/Eqhc4vwTcHQAAAU1JREFUSMekkltywyAMRQUSYPAzc/a/106dNK09xIap/kA6V0/5v7klZPXgNYfF3UYPmYPl4Ypx8whA2iwE2xIA4/wRiQp4i+4tEM0DGuvyBujgzjUqYJUkjwR+qjjc5CE9zt9FYS1StbKClnP8O2+12jPhEgS5sADpr56BHQSAUeRjRITVnQF/rGqF+H4ovsg1IMWjP6IzTHIHyATzyzuicg+IMj5TDDA0AL9xGe9aAOfJL6dJCyAG38oLxDYgwvJcomsDHIS9hSRtgKS9CWVrBbZ9/h5rBWz/hNAKBOgGukvqbrp7rN2L6z6N/uOrn7cMX5WWMQoAIAzEBMVFcfD/jxVBCGo5uMzi1CbtfUTjzWJoeMeKSlhRJKBBAmjmps4UaOYVGZTzHSAyQ5VCxjsJn4yV7mvLU+jeDgrJSgEky42in10/7P7p4B8nPguBaBuS6BA55wAAAABJRU5ErkJggg=="

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'articleCon',
    data: function data() {
        return {
            baseUrl: global.apiDomain,
            imgMode: 'loading',
            con: [],
            video_height: 0,
            UUID: '',
            voteObj: {},
            createDomData: function createDomData() {},
            voteId: ''
        };
    },
    props: ['bodydata', 'afhao'],
    computed: {
        subtitChoose: function subtitChoose() {
            if (this.$route.params.subtitle) {
                return this.$route.params.subtitle;
            }
            if (this.$store.state.navStore && this.$store.state.navStore.subtitChoose) {
                return this.$store.state.navStore.subtitChoose;
            }
            return 'Headline';
        }
    },
    created: function created() {
        var that = this;
    },
    filters: {},
    mounted: function mounted() {
        var that = this;

        this.createDomData = function (rawHtml) {
            var main = document.querySelector('#articleMain');
            var html = main.childNodes[0].childNodes;
            for (var i = 0; i < html.length; i++) {
                var item = html[i];
                var child = item.children || null;
                var data = {
                    type: 'blank'
                };
                if (item.nodeType === 1) {
                    if (item.tagName === 'P') {
                        if (child.length) {
                            child = child[0];
                            if (child.tagName === 'IMG') {
                                var tips = '';
                                if (child.nextElementSibling) {
                                    tips = child.nextElementSibling.innerText;
                                }
                                var _width = parseInt(child.getAttribute('data-width') || 0);
                                var _height = parseInt(child.getAttribute('data-height') || 0);
                                var height = _width && _height ? _height / _width * this.mainWidth : '';
                                data = {
                                    type: 'img',
                                    dataSrc: child.getAttribute('data-src') || child.getAttribute('src'),
                                    origSrc: child.getAttribute('orig-src') || child.getAttribute('src'),
                                    dataHeight: height ? height + 'px' : '',
                                    mode: this.imgMode,
                                    src: '',
                                    tips: tips
                                };
                                if (child.className === 'data-gif-src') {
                                    var _tips = '';
                                    if (child.nextElementSibling) {
                                        _tips = child.nextElementSibling.innerText;
                                    }
                                    data['type'] = 'gif';
                                    data['dataGifSrc'] = child.getAttribute('data-gif-src');
                                    data['mode'] = this.imgMode;
                                    data['showReal'] = false;
                                    data['loaded'] = false;
                                    data['tips'] = _tips;
                                }
                            } else if (child.tagName === 'AUDIO') {
                                data = {
                                    type: 'music',
                                    'artist': child.getAttribute('artist'),
                                    'src': child.getAttribute('src'),
                                    'title': child.getAttribute('title')
                                };
                            } else {
                                var reg = /allfootball:\/\/\/?news\/(\d+)/g;
                                var con = item.innerHTML && item.innerHTML.toString();
                                if (con) {
                                    con = con.replace(reg, '/news/' + this.getUrlTitle(this.subtitChoose) + '/' + this.getUrlTitle(child.innerText) + '/$1');
                                    con = con.replace(/allfootball:\/\/\/?[^'"]*/g, '/download');
                                }

                                data.type = 'text';
                                data.con = con;
                            }
                        } else {
                            var _reg = /allfootball:\/\/\/?news\/(\d+)/g;
                            var _con = item.innerHTML && item.innerHTML.toString();
                            if (_con) {
                                _con = _con.replace(_reg, '/news/' + this.getUrlTitle(this.subtitChoose) + '/$1');
                                _con = _con.replace(/allfootball:\/\/\/?[^'"]*/g, '/download');
                            }

                            data.type = 'text';
                            data.con = _con;
                        }
                    } else if (item.className === 'video') {
                        var _tips2 = '';
                        if (item.nextElementSibling.tagName === 'SPAN') {
                            _tips2 = item.nextElementSibling.innerText;
                        }
                        data = {
                            type: 'video',
                            src: item.getAttribute('src'),
                            mode: item.getAttribute('mode'),
                            android_mode: item.getAttribute('android_mode'),
                            ios_mode: item.getAttribute('ios_mode'),
                            title: item.getAttribute('title'),
                            thumb: item.getAttribute('thumb'),
                            hash: item.getAttribute('hash'),
                            site: item.getAttribute('site'),
                            videoStyle: {},
                            tips: _tips2
                        };
                    } else if (item.className === 'vote') {
                        data = {
                            type: 'votes',
                            id: item.getAttribute('rel'),
                            ready: false
                        };
                    } else if (item.tagName === 'H2' || item.tagName === 'H3') {
                        data = {
                            tagName: item.tagName,
                            type: 'subtitle',
                            con: item.innerText
                        };
                    }
                    this.con.push(data);
                }
            }
        };

        this.createDomData();

        var vote_ids = [];
        for (var i = 0; i < this.con.length; i++) {
            var item = this.con[i];
            if (item.type === 'votes') {
                vote_ids += item.id + '_';
            }
            if (item.type === 'music') {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'pause', true);
            }
        }
        if (vote_ids.length > 0) {
            var fingerJs = __webpack_require__(723);
            this.UUID = 'CA' + new fingerJs.Fingerprint({ canvas: true }).get();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(that.baseUrl + '/m/poll?id=' + vote_ids, {
                headers: {
                    UUID: this.UUID
                }
            }).then(function (response) {
                var data = response.data;
                for (var _i = 0; _i < that.con.length; _i++) {
                    var _item = that.con[_i];
                    if (_item.type === 'votes') {
                        var voteType = data[0].max_vote > 1 ? 'checkbox' : 'radio';
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'max_vote', data[0].max_vote);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'voteType', voteType);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'title', data[0].title);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'voted', data[0].voted);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'options', data[0].options);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'ready', true);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'selCounter', 0);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_item, 'selList', []);
                        data.splice(0, 1);
                    }
                    if (!data.length) {
                        break;
                    }
                }
            }, function (response) {});
        }
        this.loadImages();
        this.mainWidth = document.documentElement.clientWidth || window.screen.width;
        this.video_height = (this.mainWidth - 30) * 9 / 16 - 40;
    },

    methods: {
        checkMode: function checkMode(item) {
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            var mode = item.mode;
            var android_mode = item.android_mode;
            var ios_mode = item.ios_mode;
            if (mode == 'player') {
                return true;
            }
            if (browers.Android && android_mode == 'player') {
                return true;
            }
            if (browers.iOS && ios_mode == 'player') {
                return true;
            }
            return false;
        },

        loadImages: function loadImages() {
            var imagesItem = this.con.filter(function (x) {
                if (x.type === 'img' || x.type === 'gif') {
                    return x;
                }
            });
            for (var i = 0, len = imagesItem.length; i < len; i++) {
                var item = imagesItem[i];
                this.imgSrc(item, item.dataSrc);
            }
        },
        showImg: function showImg(item) {
            if (item.mode === 'off') {
                item.mode = 'loading';
                this.imgSrc(item, item['dataSrc']);
            } else {}
        },
        showGifImg: function showGifImg(item) {
            if (item.mode === 'off') {
                item.mode = 'loading';
                this.imgSrc(item, item['dataSrc']);
            } else if (item.mode === 'on') {
                item.mode = 'gifLoading';
                this.imgSrc(item, item['dataGifSrc']);
            } else {}
        },
        imgSrc: function imgSrc(item, src) {
            if (src !== '') {
                item.src = src;
            }
        },
        imgLoaded: function imgLoaded(item) {
            if (item.mode === 'loading') {
                item.mode = 'on';
            }
        },
        gifLoaded: function gifLoaded(item) {
            if (item.mode === 'loading') {
                item.mode = 'on';
            } else {
                item.mode = 'gif';
            }
        },

        optionSel: function optionSel(item, index, box) {
            var selList = box.selList;
            if (box.max_vote == 1) {

                selList[0] = item.id;
                box.options.forEach(function (item) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'sel', false);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'voted', false);
                });
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'voted', true);
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'sel', true);
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(box, 'selCounter', 1);
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(box, 'selList', selList);
            } else {
                if (box.selCounter < box.max_vote) {
                    if (item.voted) {
                        selList.forEach(function (sel_id, i) {
                            if (sel_id === item.id) {
                                selList.splice(i, 1);
                            }
                        });
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'sel', false);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(box, 'selCounter', box.selCounter - 1);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(box, 'selList', selList);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'voted', false);
                    } else {
                        selList.push(item.id);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'sel', true);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(box, 'selCounter', box.selCounter + 1);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(box, 'selList', selList);
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'voted', true);
                    }
                }
            }
        },
        optionSub: function optionSub(item) {
            var that = this;
            var data = {
                id: item.id,
                list: item.selList
            };

            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(item, 'voted', true);
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(that.baseUrl + '/m/poll/commit', data, {
                headers: {
                    UUID: this.UUID
                }
            }).then(function (response) {}, function (error) {});
        },
        audioPlay: function audioPlay(item, event) {
            var musicBox = event.target.parentNode.parentNode;
            var music = musicBox.getElementsByTagName('audio')[0];
            var curPro = musicBox.getElementsByClassName('progress')[0];
            music.play();

            item.pause = false;
            var musicPlay = window.setInterval(function () {
                var cur = music.currentTime / music.duration * 100 + '%';
                if (music.currentTime === music.duration) {
                    window.clearInterval('musicPlay');
                    item.pause = true;
                }
                curPro.style.width = cur;
            }, 1000);
        },
        audioPause: function audioPause(item) {
            var musicBox = event.target.parentNode.parentNode;
            var music = musicBox.getElementsByTagName('audio')[0];
            music.pause();
            window.clearInterval('musicPlay');
            item.pause = true;
        },
        videoPlay: function videoPlay(url) {
            var query = this.$route.query;
            if (query && query.type === 'share') {
                var utilObj = __webpack_require__(500);
                utilObj.jumpUrl();
                return;
            }
            if (url) {
                location.href = url;
            }
        },
        afhaoReport: function afhaoReport() {
            console.log('======');
            return false;
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

(function (name, context, definition) {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = definition();
  } else {
    if (typeof define === "function" && __webpack_require__(739)) {
      define(definition);
    } else {
      context[name] = definition();
    }
  }
})("Fingerprint", this, function () {
  var Fingerprint = function Fingerprint(options) {
    var nativeForEach, nativeMap;nativeForEach = Array.prototype.forEach;nativeMap = Array.prototype.map;this.each = function (obj, iterator, context) {
      if (obj === null) {
        return;
      }if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
      } else {
        if (obj.length === +obj.length) {
          for (var i = 0, l = obj.length; i < l; i++) {
            if (iterator.call(context, obj[i], i, obj) === {}) {
              return;
            }
          }
        } else {
          for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
              if (iterator.call(context, obj[key], key, obj) === {}) {
                return;
              }
            }
          }
        }
      }
    };this.map = function (obj, iterator, context) {
      var results = [];if (obj == null) {
        return results;
      }if (nativeMap && obj.map === nativeMap) {
        return obj.map(iterator, context);
      }this.each(obj, function (value, index, list) {
        results[results.length] = iterator.call(context, value, index, list);
      });return results;
    };if ((typeof options === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) == "object") {
      this.hasher = options.hasher;this.screen_resolution = options.screen_resolution;this.screen_orientation = options.screen_orientation;this.canvas = options.canvas;this.ie_activex = options.ie_activex;
    } else {
      if (typeof options == "function") {
        this.hasher = options;
      }
    }
  };Fingerprint.prototype = { get: function get() {
      var keys = [];keys.push(navigator.userAgent);keys.push(navigator.language);keys.push(screen.colorDepth);if (this.screen_resolution) {
        var resolution = this.getScreenResolution();if (typeof resolution !== "undefined") {
          keys.push(resolution.join("x"));
        }
      }keys.push(new Date().getTimezoneOffset());keys.push(this.hasSessionStorage());keys.push(this.hasLocalStorage());keys.push(this.hasIndexDb());if (document.body) {
        keys.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(document.body.addBehavior));
      } else {
        keys.push( true ? "undefined" : _typeof(undefined));
      }keys.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(window.openDatabase));keys.push(navigator.cpuClass);keys.push(navigator.platform);keys.push(navigator.doNotTrack);keys.push(this.getPluginsString());if (this.canvas && this.isCanvasSupported()) {
        keys.push(this.getCanvasFingerprint());
      }if (this.hasher) {
        return this.hasher(keys.join("###"), 31);
      } else {
        return this.murmurhash3_32_gc(keys.join("###"), 31);
      }
    }, murmurhash3_32_gc: function murmurhash3_32_gc(key, seed) {
      var remainder, bytes, h1, h1b, c1, c2, k1, i;remainder = key.length & 3;bytes = key.length - remainder;h1 = seed;c1 = 3432918353;c2 = 461845907;i = 0;while (i < bytes) {
        k1 = key.charCodeAt(i) & 255 | (key.charCodeAt(++i) & 255) << 8 | (key.charCodeAt(++i) & 255) << 16 | (key.charCodeAt(++i) & 255) << 24;++i;k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;k1 = k1 << 15 | k1 >>> 17;k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;h1 ^= k1;h1 = h1 << 13 | h1 >>> 19;h1b = (h1 & 65535) * 5 + (((h1 >>> 16) * 5 & 65535) << 16) & 4294967295;h1 = (h1b & 65535) + 27492 + (((h1b >>> 16) + 58964 & 65535) << 16);
      }k1 = 0;switch (remainder) {case 3:
          k1 ^= (key.charCodeAt(i + 2) & 255) << 16;case 2:
          k1 ^= (key.charCodeAt(i + 1) & 255) << 8;case 1:
          k1 ^= key.charCodeAt(i) & 255;k1 = (k1 & 65535) * c1 + (((k1 >>> 16) * c1 & 65535) << 16) & 4294967295;k1 = k1 << 15 | k1 >>> 17;k1 = (k1 & 65535) * c2 + (((k1 >>> 16) * c2 & 65535) << 16) & 4294967295;h1 ^= k1;}h1 ^= key.length;h1 ^= h1 >>> 16;h1 = (h1 & 65535) * 2246822507 + (((h1 >>> 16) * 2246822507 & 65535) << 16) & 4294967295;h1 ^= h1 >>> 13;h1 = (h1 & 65535) * 3266489909 + (((h1 >>> 16) * 3266489909 & 65535) << 16) & 4294967295;h1 ^= h1 >>> 16;return h1 >>> 0;
    }, hasLocalStorage: function hasLocalStorage() {
      try {
        return !!window.localStorage;
      } catch (e) {
        return true;
      }
    }, hasSessionStorage: function hasSessionStorage() {
      try {
        return !!window.sessionStorage;
      } catch (e) {
        return true;
      }
    }, hasIndexDb: function hasIndexDb() {
      try {
        return !!window.indexedDB;
      } catch (e) {
        return true;
      }
    }, isCanvasSupported: function isCanvasSupported() {
      var elem = document.createElement("canvas");return !!(elem.getContext && elem.getContext("2d"));
    }, isIE: function isIE() {
      if (navigator.appName === "Microsoft Internet Explorer") {
        return true;
      } else {
        if (navigator.appName === "Netscape" && /Trident/.test(navigator.userAgent)) {
          return true;
        }
      }return false;
    }, getPluginsString: function getPluginsString() {
      if (this.isIE() && this.ie_activex) {
        return this.getIEPluginsString();
      } else {
        return this.getRegularPluginsString();
      }
    }, getRegularPluginsString: function getRegularPluginsString() {
      return this.map(navigator.plugins, function (p) {
        var mimeTypes = this.map(p, function (mt) {
          return [mt.type, mt.suffixes].join("~");
        }).join(",");return [p.name, p.description, mimeTypes].join("::");
      }, this).join(";");
    }, getIEPluginsString: function getIEPluginsString() {
      if (window.ActiveXObject) {
        var names = ["ShockwaveFlash.ShockwaveFlash", "AcroPDF.PDF", "PDF.PdfCtrl", "QuickTime.QuickTime", "rmocx.RealPlayer G2 Control", "rmocx.RealPlayer G2 Control.1", "RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)", "RealVideo.RealVideo(tm) ActiveX Control (32-bit)", "RealPlayer", "SWCtl.SWCtl", "WMPlayer.OCX", "AgControl.AgControl", "Skype.Detection"];return this.map(names, function (name) {
          try {
            new ActiveXObject(name);return name;
          } catch (e) {
            return null;
          }
        }).join(";");
      } else {
        return "";
      }
    }, getScreenResolution: function getScreenResolution() {
      var resolution;if (this.screen_orientation) {
        resolution = screen.height > screen.width ? [screen.height, screen.width] : [screen.width, screen.height];
      } else {
        resolution = [screen.height, screen.width];
      }return resolution;
    }, getCanvasFingerprint: function getCanvasFingerprint() {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");var txt = "http://www.dongqiudi.com";ctx.textBaseline = "top";ctx.font = "14px 'Arial'";ctx.textBaseline = "alphabetic";ctx.fillStyle = "#f60";ctx.fillRect(125, 1, 62, 20);ctx.fillStyle = "#069";ctx.fillText(txt, 2, 15);ctx.fillStyle = "rgba(102, 204, 0, 0.7)";ctx.fillText(txt, 4, 17);return canvas.toDataURL();
    } };return Fingerprint;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(724)(module)))

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(726);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(728);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(727), __esModule: true };

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133);
__webpack_require__(327);
module.exports = __webpack_require__(596).f('iterator');


/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(729), __esModule: true };

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(730);
__webpack_require__(322);
__webpack_require__(737);
__webpack_require__(738);
module.exports = __webpack_require__(32).Symbol;


/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(19);
var has = __webpack_require__(63);
var DESCRIPTORS = __webpack_require__(57);
var $export = __webpack_require__(48);
var redefine = __webpack_require__(324);
var META = __webpack_require__(731).KEY;
var $fails = __webpack_require__(85);
var shared = __webpack_require__(134);
var setToStringTag = __webpack_require__(91);
var uid = __webpack_require__(128);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(596);
var wksDefine = __webpack_require__(597);
var keyOf = __webpack_require__(732);
var enumKeys = __webpack_require__(733);
var isArray = __webpack_require__(734);
var anObject = __webpack_require__(50);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(187);
var createDesc = __webpack_require__(89);
var _create = __webpack_require__(325);
var gOPNExt = __webpack_require__(735);
var $GOPD = __webpack_require__(736);
var $DP = __webpack_require__(56);
var $keys = __webpack_require__(126);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(606).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(186).f = $propertyIsEnumerable;
  __webpack_require__(189).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(127)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key) {
    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(49)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(128)('meta');
var isObject = __webpack_require__(64);
var has = __webpack_require__(63);
var setDesc = __webpack_require__(56).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(85)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(126);
var toIObject = __webpack_require__(87);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};


/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(189);
var pIE = __webpack_require__(186);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(65);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(87);
var gOPN = __webpack_require__(606).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(186);
var createDesc = __webpack_require__(89);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(187);
var has = __webpack_require__(63);
var IE8_DOM_DEFINE = __webpack_require__(323);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(57) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597)('asyncIterator');


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597)('observable');


/***/ }),

/***/ 739:
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('div', {
    staticClass: "con",
    attrs: {
      "id": "articleMain"
    }
  }, [(_vm.con.length == 0) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.bodydata)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.con), function(item, i) {
    return [(item.type == 'text') ? [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.con)
      }
    })] : _vm._e(), _vm._v(" "), (item.type == 'img') ? [_c('div', {
      staticClass: "img-container",
      class: item.mode,
      style: (item.dataHeight ? 'height:' + item.dataHeight : ''),
      on: {
        "click": function($event) {
          _vm.showImg(item, $event)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mode === 'on'),
        expression: "item.mode === 'on'"
      }],
      staticClass: "imgs",
      class: item.mode,
      attrs: {
        "src": _vm.getImgSrc(item.src)
      },
      on: {
        "load": function($event) {
          _vm.imgLoaded(item)
        }
      }
    })])], 1), _vm._v(" "), (item.tips) ? _c('span', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()] : _vm._e(), _vm._v(" "), (item.type == 'gif') ? [_c('div', {
      staticClass: "img-container",
      class: item.mode,
      style: (item.dataHeight ? 'height:' + item.dataHeight : ''),
      on: {
        "click": function($event) {
          _vm.showGifImg(item, $event)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mode === 'on' || item.mode === 'gifLoading' || item.mode === 'gif'),
        expression: "item.mode === 'on' || item.mode === 'gifLoading' || item.mode === 'gif'"
      }],
      staticClass: "data-gif-src",
      class: item.mode,
      attrs: {
        "src": _vm.getImgSrc(item.src)
      },
      on: {
        "load": function($event) {
          _vm.gifLoaded(item)
        }
      }
    })]), _vm._v(" "), (item.mode !== 'gif') ? _c('div', {
      staticClass: "media-loader"
    }) : _vm._e(), _vm._v(" "), (item.mode === 'on') ? _c('div', {
      staticClass: "media-holder"
    }) : _vm._e(), _vm._v(" "), (item.mode === 'on') ? _c('div', {
      staticClass: "media-label"
    }) : _vm._e()], 1), _vm._v(" "), (item.tips) ? _c('span', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()] : _vm._e(), _vm._v(" "), (item.type == 'music') ? [_c('div', {
      staticClass: "audio"
    }, [_c('audio', {
      attrs: {
        "preload": "off",
        "src": _vm.getImgSrc(item.src)
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "main playing"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.artist))]), _vm._v(" "), (item.pause) ? _c('a', {
      staticClass: "play",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.audioPlay(item, $event)
        }
      }
    }) : _c('a', {
      staticClass: "pause",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.audioPause(item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    })])] : _vm._e(), _vm._v(" "), (item.type == 'video') ? [(_vm.checkMode(item)) ? _c('section', {
      staticClass: "video"
    }, [_c('video', {
      style: ('background:url(' + _vm.getImgSrc(item.thumb) + ') top center no-repeat rgba(0,0,0,0.7);background-size: cover;'),
      attrs: {
        "src": _vm.getImgSrc(item.src),
        "controls": "controls"
      },
      on: {
        "play": function($event) {
          _vm.videoPlay()
        }
      }
    })]) : [_c('div', {
      staticClass: "mask"
    }), _vm._v(" "), (item.thumb) ? _c('div', {
      staticClass: "media-container media-container-video",
      style: ({
        'backgroundImage': 'url(' + _vm.getImgSrc(item.thumb) + ')',
        'height': _vm.video_height + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.videoPlay(item.src)
        }
      }
    }, [_c('div', {
      staticClass: "media-holder media-holder-video"
    })]) : _c('div', {
      staticClass: "media-container media-container-video",
      style: ({
        'height': _vm.video_height + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.videoPlay(item.src)
        }
      }
    }, [_c('div', {
      staticClass: "media-holder media-holder-video"
    })]), _vm._v(" "), (item.tips) ? _c('span', {
      staticClass: "tips_v"
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()]] : _vm._e(), _vm._v(" "), (item.type == 'subtitle') ? [(item.tagName === 'H2') ? _c('h2', [_c('span', {
      staticClass: "border"
    }), _vm._v(_vm._s(item.con))]) : _c('h3', [_c('span', {
      staticClass: "border"
    }), _vm._v(_vm._s(item.con))])] : _vm._e(), _vm._v(" "), (item.type == 'votes') ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ready),
        expression: "item.ready"
      }],
      staticClass: "vote_box"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      class: item.voteType
    }, [(!item.voted) ? [_c('dl', [_c('dt', [_vm._v("\n                                    " + _vm._s(item.title) + "\n                                    "), _c('span', [(item.voteType === 'checkbox') ? [_vm._v("\n                        (allow " + _vm._s(item.max_vote) + " options)\n                      ")] : _vm._e()], 2)]), _vm._v(" "), _vm._l((item.options), function(option, index) {
      return [(option.sel) ? _c('dd', {
        staticClass: "checked",
        on: {
          "click": function($event) {
            _vm.optionSel(option, index, item)
          }
        }
      }, [_c('span', {
        staticClass: "tag"
      }), _vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (!option.sel) ? _c('dd', {
        on: {
          "click": function($event) {
            _vm.optionSel(option, index, item)
          }
        }
      }, [_c('span', {
        staticClass: "tag"
      }), _vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [(item.selCounter > 0) ? _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.optionSub(item)
        }
      }
    }, [_vm._v("Submit")]) : _c('a', {
      staticClass: "btn btn_dis"
    }, [_vm._v("Submit")])])] : _vm._e(), _vm._v(" "), (item.voted) ? [_c('dl', {
      staticClass: "re"
    }, [_c('dt', [_vm._v("\n                                    " + _vm._s(item.title) + "\n                                    "), _c('span', [(item.voteType === 'checkbox') ? [_vm._v("\n                        (allow " + _vm._s(item.max_vote) + " options)\n                      ")] : _vm._e()], 2)]), _vm._v(" "), _vm._l((item.options), function(option, index) {
      return [_c('dd', [_c('h3', [_vm._v("\n                                            " + _vm._s(option.title) + " "), (option.voted) ? _c('em', [_vm._v("voted")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.stat) + "%")])]), _vm._v(" "), _c('div', {
        staticClass: "rank"
      }, [_c('div', {
        staticClass: "bar",
        class: option.voted ? 'voted' : '',
        style: ({
          width: option.stat + '%'
        })
      })])])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [(item.selCounter > 0) ? _c('p', [_vm._v("Thanks for voting")]) : _c('p', [_vm._v("Voting is over")])])] : _vm._e()], 2)])] : _vm._e()]
  })], 2), _vm._v(" "), [(!_vm.afhao || _vm.afhao.length === 0 || JSON.stringify(_vm.afhao) === '{}') ? _c('div', {
    staticClass: "declare"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "afhaoBottom clearfix"
  }, [_c('p', {
    staticClass: "afhaoAbout"
  }, [_c('a', {
    attrs: {
      "href": _vm.afhao.intro_schema
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(741)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('AboutUserPosts')))])])]), _vm._v(" "), _c('p', {
    staticClass: "afhaoReport",
    on: {
      "click": function($event) {
        _vm.afhaoReport()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(742),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Report')))])])])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('span', [_vm._v("Vote")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://api.allfootballapp.com/about/copyright"
    }
  }, [_vm._v("Copyright Declaration")])])
}]}

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAbFBMVEUAAACRmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ3U4O41AAAAI3RSTlMA8oYP+WtRHwfFjHs5uJd2MCsbFQG9q4FhW1ZGPSTszqJJsfDF/BMAAADSSURBVCjPdZLZFoIwDESHllpWEVxAFLf5/380YM4Bq9yHPmQyTZoUiq/KG3krqwFLmgeFKKLw8HN8EzPOCgvYwoh4huLIzEJJDFlpPrnBgqd6rMZnLmQD4MQtAgxLoGF8QEjEAbkaAovBkVf8sGMqrv3YWS7nJW+Q5G7smTHIw5ghKZ68IyO7qchHqMkSflRbsp8EverqEqBwFnBnvWql+H29Xf//gfXKSI5y7v8N0UPoyT4Ye4eJKlxUC6Xj12rd7B5O82d41VhSt2kkUmp2GngDMMcTw4aQloQAAAAASUVORK5CYII="

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAACRmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ2RmJ0M0ciDAAAAIXRSTlMAH23fxyh59zUwdXIZEejRsQjlXFfw17mopGVSu6GAYEbaoSHPAAAA1klEQVQoz1WS16LDIAxDTQiQ0aym+87z/z/ZtMFA9YKwQHggEaa/nuH83TkpcfgBGI8Ad5PjJxh9u4gsrtvEVeMVdJLQQ7+zL2ikQAOn1zpovJ3vshMYtmXWm/+QvOctIUbRg1bdjhjxVHHnuOR0vNQYrZFJCkpIVVKLIiDZeCiESykshTAhIIpPq/y4DEt+birSlSYdefArJhXYgSr2xWa90ifhwXVvYhvb3GgLOMQxfbS9DaxqHt10bF75CrZyb5fKwp8kmBuAtQA3IyWcrwOE2uv3eQIC/hEloRTCfQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(745);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("dd7aff58", content, true);

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".infos{margin:0 15px;padding:0}.infos p{margin:5px 0}#channels{padding:5px 0 34px;font-size:13px;color:#8c9399;line-height:34px}#channels a{display:inline-block;position:relative;bottom:2px;padding:4px 8px;margin:0 5px 0 0;line-height:16px;background:#eff1f4;border-radius:2px;vertical-align:middle;height:16px;color:#606369;-webkit-tap-highlight-color:rgba(0,0,0,0)}.column-ad{margin:0 15px 29px}.column-ad a{display:block;width:100%;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.column-ad img{width:100%;margin:0;padding:0}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/infos.vue"],"names":[],"mappings":"AACA,OACI,cAAiB,AACjB,SAAW,CACd,AACD,SACI,YAAc,CACjB,AACD,UACI,mBAAoB,AACpB,eAAgB,AAChB,cAAe,AACf,gBAAkB,CACrB,AACD,YACI,qBAAsB,AACtB,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,iBAAkB,AAClB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,sBAAuB,AACvB,YAAa,AACb,cAAe,AACf,yCAA8C,CACjD,AACD,WACI,kBAAoB,CACvB,AACD,aACI,cAAe,AACf,WAAY,AACZ,wCAAyC,AACzC,2BAA4B,AAC5B,yBAA0B,AAC1B,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC1B,AACD,eACI,WAAY,AACZ,SAAU,AACV,SAAW,CACd","file":"infos.vue","sourcesContent":["\n.infos {\n    margin: 0 15px 0;\n    padding: 0;\n}\n.infos p {\n    margin: 5px 0;\n}\n#channels {\n    padding: 5px 0 34px;\n    font-size: 13px;\n    color: #8c9399;\n    line-height: 34px;\n}\n#channels a {\n    display: inline-block;\n    position: relative;\n    bottom: 2px;\n    padding: 4px 8px;\n    margin: 0 5px 0 0;\n    line-height: 16px;\n    background: #eff1f4;\n    border-radius: 2px;\n    vertical-align: middle;\n    height: 16px;\n    color: #606369;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.column-ad {\n    margin: 0 15px 29px;\n}\n.column-ad a {\n    display: block;\n    width: 100%;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n     -ms-user-select: none;\n         user-select: none;\n}\n.column-ad img {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'infos',
    data: function data() {
        return {
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
        };
    },

    props: ['infos']
});

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.infos.channels.length > 0) ? _c('div', {
    staticClass: "infos"
  }, [(_vm.infos.channels.length) ? _c('div', {
    attrs: {
      "id": "channels"
    }
  }, [_vm._v("\n            Related：\n            "), _vm._l((_vm.infos.channels), function(channels) {
    return [_c('a', {
      key: channels.tag,
      attrs: {
        "href": _vm.isInApp ? channels.href : 'javascript:void(0);'
      },
      domProps: {
        "innerHTML": _vm._s(channels.tag)
      }
    })]
  })], 2) : _vm._e()]) : _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), (_vm.infos.column.id) ? _c('div', {
    staticClass: "column-ad"
  }, [_c('a', {
    attrs: {
      "href": _vm.isInApp ? _vm.infos.column.href : 'javascript:void(0);'
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.infos.column.show_footer_image)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(753),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("00a551f5", content, true);

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#relatedNews{padding-bottom:38px}#relatedNews .list-title{display:inline-block;height:20px;font-size:16px;font-weight:600;line-height:20px;color:#2d2f32}#relatedNews .list-title:before{display:inline-block;height:24px;width:3px;margin-right:12px;vertical-align:middle;content:\"\";background-color:#16b13a}#relatedNews .detail{margin:0 15px;padding:12px 0;border-bottom:1px solid #eff1f4;position:relative}#relatedNews .detail:first-of-type a{margin:14px 0 0}#relatedNews .detail a{display:block;padding-left:85px;position:relative;min-height:43px;padding-bottom:12px}#relatedNews .detail-img,#relatedNews .detail-img-video{background-color:#e9e9e9;width:75px;height:55px;position:absolute;left:0;background-repeat:no-repeat}#relatedNews .detail-img{background-position:50%;background-size:100% auto}#relatedNews .detail-img-video{background-color:#e9e9e9;background-position:50%,50%;background-size:24px auto,100% auto}#relatedNews .detail-title{line-height:19px;margin:0;color:#2d2f32;font-size:15px;position:relative;bottom:2px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;min-height:38px;max-height:58px;-webkit-line-clamp:3;-moz-line-clamp:3;-o-line-clamp:3;-ms-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical;-o-box-orient:vertical;-ms-box-orient:vertical;box-orient:vertical}#relatedNews span{color:#8c9399;font-size:11px}#relatedNews .detail-time{float:left;line-height:21px}#relatedNews .detail-comments{display:block;text-align:right;position:absolute;right:0;bottom:-1px;height:14px}#relatedNews .detail-comments:after{display:inline-block;background:url(" + __webpack_require__(751) + ") 50% no-repeat;background-size:13px auto;content:\"\";width:13px;margin-left:4px;position:relative;top:3px;height:14px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/components/relatedNews.vue"],"names":[],"mappings":"AACA,aACI,mBAAqB,CACxB,AACD,yBACI,qBAAsB,AACtB,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,aAAe,CAClB,AACD,gCACI,qBAAsB,AACtB,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,sBAAuB,AACvB,WAAY,AACZ,wBAA0B,CAC7B,AACD,qBACI,cAAe,AACf,eAAgB,AAChB,gCAAiC,AACjC,iBAAmB,CACtB,AACD,qCACI,eAAiB,CACpB,AACD,uBACI,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,mBAAqB,CACxB,AACD,wDAEI,yBAA0B,AAC1B,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,OAAQ,AACR,2BAA6B,CAChC,AACD,yBACI,wBAAmC,AACnC,yBAA2B,CAC9B,AACD,+BACI,yBAA0B,AAC1B,4BAAkD,AAClD,mCAAsC,CACzC,AACD,2BACI,iBAAkB,AAClB,SAAU,AACV,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,uBAAwB,AACxB,oBAAqB,AACrB,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,kBAAmB,AACnB,gBAAiB,AACjB,iBAAkB,AAClB,aAAc,AAEd,4BAA6B,AAC7B,uBAAwB,AACxB,wBAAyB,AACzB,mBAAqB,CACxB,AACD,kBACI,cAAe,AACf,cAAgB,CACnB,AACD,0BACI,WAAY,AACZ,gBAAkB,CACrB,AACD,8BACI,cAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,QAAS,AACT,YAAa,AACb,WAAa,CAChB,AACD,oCACI,qBAAsB,AACtB,uDAAmE,AACnE,0BAA2B,AAC3B,WAAY,AACZ,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,QAAS,AACT,WAAa,CAChB","file":"relatedNews.vue","sourcesContent":["\n#relatedNews {\n    padding-bottom: 38px;\n}\n#relatedNews .list-title {\n    display: inline-block;\n    height: 20px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20px;\n    color: #2d2f32;\n}\n#relatedNews .list-title:before {\n    display: inline-block;\n    height: 24px;\n    width: 3px;\n    margin-right: 12px;\n    vertical-align: middle;\n    content: \"\";\n    background-color: #16b13a;\n}\n#relatedNews .detail {\n    margin: 0 15px;\n    padding: 12px 0;\n    border-bottom: 1px solid #eff1f4;\n    position: relative;\n}\n#relatedNews .detail:nth-of-type(1) a {\n    margin: 14px 0 0;\n}\n#relatedNews .detail a {\n    display: block;\n    padding-left: 85px;\n    position: relative;\n    min-height: 43px;\n    padding-bottom: 12px;\n}\n#relatedNews .detail-img,\n#relatedNews .detail-img-video {\n    background-color: #e9e9e9;\n    width: 75px;\n    height: 55px;\n    position: absolute;\n    left: 0;\n    background-repeat: no-repeat;\n}\n#relatedNews .detail-img {\n    background-position: center center;\n    background-size: 100% auto;\n}\n#relatedNews .detail-img-video {\n    background-color: #e9e9e9;\n    background-position: center center, center center;\n    background-size: 24px auto, 100% auto;\n}\n#relatedNews .detail-title {\n    line-height: 19px;\n    margin: 0;\n    color: #2d2f32;\n    font-size: 15px;\n    position: relative;\n    bottom: 2px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    min-height: 38px;\n    max-height: 58px;\n    -webkit-line-clamp: 3;\n    -moz-line-clamp: 3;\n    -o-line-clamp: 3;\n    -ms-line-clamp: 3;\n    line-clamp: 3;\n\n    -webkit-box-orient: vertical;\n    -o-box-orient: vertical;\n    -ms-box-orient: vertical;\n    box-orient: vertical;\n}\n#relatedNews span {\n    color: #8c9399;\n    font-size: 11px;\n}\n#relatedNews .detail-time {\n    float: left;\n    line-height: 21px;\n}\n#relatedNews .detail-comments {\n    display: block;\n    text-align: right;\n    position: absolute;\n    right: 0;\n    bottom: -1px;\n    height: 14px;\n}\n#relatedNews .detail-comments:after {\n    display: inline-block;\n    background: url(\"../assets/i_comment.png\") center center no-repeat;\n    background-size: 13px auto;\n    content: \"\";\n    width: 13px;\n    margin-left: 4px;\n    position: relative;\n    top: 3px;\n    height: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 751:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZBAMAAADd8CNTAAAAMFBMVEUAAACMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5mMk5kkTwceAAAAD3RSTlMA6UmOxVI60Jl+dCrXph1+lJOdAAAAYklEQVQY02Nglv8PAx8NGOz/I8BnBvkEBhhg+8jwnwEB/lONxySoAEFgHuN/AQhC5aGrpIlb5APgHNaPDOvBYfCnj9v///9fDJzQUGoBhtIEqCLu+/8LkAxg8xdgQAKsIDkAjJNYjfTpaRIAAAAASUVORK5CYII="

/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'relatedNews',
    props: ['articleId'],
    data: function data() {
        return {
            relatedNews: [],
            article_id: this.articleId,
            loadRelatedNews: false
        };
    },

    computed: {
        subtitChoose: function subtitChoose() {
            if (this.$route.params.subtitle) {
                return this.$route.params.subtitle;
            }
            if (this.$store.state.navStore && this.$store.state.navStore.subtitChoose) {
                return this.$store.state.navStore.subtitChoose;
            }
            return 'Headline';
        }
    },
    created: function created() {
        var type = this.$route.query.type;
        if (type === 'share') {
            this.loadRelatedNews = false;
        } else {
            this.init();
        }
    },
    methods: {
        init: function init() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(global.apiDomain + '/m/v2/article/relate/' + this.article_id + '?plat=m').then(function (response) {

                var relatedNews = response.data.relate;

                if (relatedNews && relatedNews.length > 0) {
                    _this.loadRelatedNews = true;
                } else {
                    return;
                }
                for (var i = 0; i < relatedNews.length; i++) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(_this.relatedNews, i, relatedNews[i]);
                }
            }, function (error) {});
        },
        newsClick: function newsClick(newsId) {
            var query = this.$route.query || {};
            location.href = '/news?id=' + newsId;
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadRelatedNews) ? _c('div', {
    attrs: {
      "id": "relatedNews"
    }
  }, [_c('dl', [_vm._m(0), _vm._v(" "), _vm._l((_vm.relatedNews), function(news) {
    return _c('dd', {
      staticClass: "detail"
    }, [_c('a', {
      attrs: {
        "href": ("/news/" + (_vm.getUrlTitle(_vm.subtitChoose)) + "/" + (_vm.getUrlTitle(news.title)) + "/" + (news.aid) + "}")
      }
    }, [(news.type === 'video') ? _c('div', {
      staticClass: "detail-img-video",
      style: ({
        backgroundImage: 'url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png),url(' + news.thumb + ')'
      })
    }) : _c('div', {
      staticClass: "detail-img",
      style: ({
        backgroundImage: 'url(' + news.thumb + ')'
      })
    }), _vm._v(" "), _c('p', {
      staticClass: "detail-title",
      domProps: {
        "innerHTML": _vm._s(news.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "detail-time",
      domProps: {
        "innerHTML": _vm._s(news.time)
      }
    }), _vm._v(" "), (news.comments_total != 0) ? _c('span', {
      staticClass: "detail-comments",
      domProps: {
        "innerHTML": _vm._s(news.comments_total)
      }
    }) : _vm._e()])])
  })], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "list-title"
  }, [_vm._v("You may like")])])
}]}

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    attrs: {
      "id": "mainwrap"
    }
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n        professional APP.")]) : _vm._e(), _vm._v(" "), (!_vm.isInApp) ? _vm._m(0) : _vm._e(), _vm._v(" "), (_vm.articleBody.title) ? _c('headerTitle', {
    attrs: {
      "title": _vm.articleBody.title,
      "time": _vm.articleBody.time,
      "writer": _vm.articleBody.writer,
      "afhao": _vm.articleBody.afh_info
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleBody.body) ? _c('articleCon', {
    attrs: {
      "bodydata": _vm.articleBody.body,
      "afhao": _vm.articleBody.afh_info
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleBody.infos) ? _c('infos', {
    attrs: {
      "infos": _vm.articleBody.infos
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadItem) ? _c('relatedNews', {
    attrs: {
      "articleId": _vm.articleBody.article_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadItem) ? _c('comments', {
    attrs: {
      "articleId": _vm.articleBody.article_id,
      "time": 3000
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bodyLoad && _vm.loadItem && !_vm.isInApp) ? _vm._m(1) : _vm._e(), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('downloadHeader', {
    attrs: {
      "id": "headwrap"
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('downloadFooter', {
    attrs: {
      "text": "Download All Football for more comments"
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [_vm._v("Links："), _c('a', {
    attrs: {
      "href": "http://footballlive.cc/"
    }
  }, [_vm._v("Football Live | Football Results | Player Scored")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.ecbe072ac0ecc7fc1179.js